let wasm;
export function __wbg_set_wasm(val) {
    wasm = val;
}


let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
    if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
        cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8ArrayMemory0;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
    numBytesDecoded += len;
    if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
        cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
        cachedTextDecoder.decode();
        numBytesDecoded = len;
    }
    return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return decodeText(ptr, len);
}

let heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function getObject(idx) { return heap[idx]; }

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = new TextEncoder();

if (!('encodeInto' in cachedTextEncoder)) {
    cachedTextEncoder.encodeInto = function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
            read: arg.length,
            written: buf.length
        };
    }
}

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8ArrayMemory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8ArrayMemory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
        const ret = cachedTextEncoder.encodeInto(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
    if (cachedDataViewMemory0 === null || cachedDataViewMemory0.buffer.detached === true || (cachedDataViewMemory0.buffer.detached === undefined && cachedDataViewMemory0.buffer !== wasm.memory.buffer)) {
        cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
    }
    return cachedDataViewMemory0;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches && builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => state.dtor(state.a, state.b));

function makeMutClosure(arg0, arg1, dtor, f) {
    const state = { a: arg0, b: arg1, cnt: 1, dtor };
    const real = (...args) => {

        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            state.a = a;
            real._wbg_cb_unref();
        }
    };
    real._wbg_cb_unref = () => {
        if (--state.cnt === 0) {
            state.dtor(state.a, state.b);
            state.a = 0;
            CLOSURE_DTORS.unregister(state);
        }
    };
    CLOSURE_DTORS.register(real, state, state);
    return real;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getDataViewMemory0();
    const result = [];
    for (let i = ptr; i < ptr + 4 * len; i += 4) {
        result.push(takeObject(mem.getUint32(i, true)));
    }
    return result;
}

function passArray8ToWasm0(arg, malloc) {
    const ptr = malloc(arg.length * 1, 1) >>> 0;
    getUint8ArrayMemory0().set(arg, ptr / 1);
    WASM_VECTOR_LEN = arg.length;
    return ptr;
}
/**
 * Generate a new SSH key pair
 *
 * # Arguments
 * - `key_algorithm` - The algorithm to use for the key pair
 *
 * # Returns
 * - `Ok(SshKey)` if the key was successfully generated
 * - `Err(KeyGenerationError)` if the key could not be generated
 * @param {KeyAlgorithm} key_algorithm
 * @returns {SshKeyView}
 */
export function generate_ssh_key(key_algorithm) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.generate_ssh_key(retptr, addHeapObject(key_algorithm));
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return takeObject(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
 * Convert a PCKS8 or OpenSSH encrypted or unencrypted private key
 * to an OpenSSH private key with public key and fingerprint
 *
 * # Arguments
 * - `imported_key` - The private key to convert
 * - `password` - The password to use for decrypting the key
 *
 * # Returns
 * - `Ok(SshKey)` if the key was successfully coneverted
 * - `Err(PasswordRequired)` if the key is encrypted and no password was provided
 * - `Err(WrongPassword)` if the password provided is incorrect
 * - `Err(ParsingError)` if the key could not be parsed
 * - `Err(UnsupportedKeyType)` if the key type is not supported
 * @param {string} imported_key
 * @param {string | null} [password]
 * @returns {SshKeyView}
 */
export function import_ssh_key(imported_key, password) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        const ptr0 = passStringToWasm0(imported_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(password) ? 0 : passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        wasm.import_ssh_key(retptr, ptr0, len0, ptr1, len1);
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
        if (r2) {
            throw takeObject(r1);
        }
        return takeObject(r0);
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

/**
 * @param {LogLevel | null} [log_level]
 */
export function init_sdk(log_level) {
    wasm.init_sdk(isLikeNone(log_level) ? 5 : log_level);
}

let stack_pointer = 128;

function addBorrowedObject(obj) {
    if (stack_pointer == 1) throw new Error('out of js stack');
    heap[--stack_pointer] = obj;
    return stack_pointer;
}
/**
 * @param {any} error
 * @returns {boolean}
 */
export function isTestError(error) {
    try {
        const ret = wasm.isTestError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isRegistrationError(error) {
    try {
        const ret = wasm.isRegistrationError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isPasswordPreloginError(error) {
    try {
        const ret = wasm.isPasswordPreloginError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isPasswordLoginError(error) {
    try {
        const ret = wasm.isPasswordLoginError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCollectionDecryptError(error) {
    try {
        const ret = wasm.isCollectionDecryptError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isMasterPasswordError(error) {
    try {
        const ret = wasm.isMasterPasswordError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isAccountCryptographyInitializationError(error) {
    try {
        const ret = wasm.isAccountCryptographyInitializationError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isRotateCryptographyStateError(error) {
    try {
        const ret = wasm.isRotateCryptographyStateError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDeriveKeyConnectorError(error) {
    try {
        const ret = wasm.isDeriveKeyConnectorError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isMakeKeysError(error) {
    try {
        const ret = wasm.isMakeKeysError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEnrollAdminPasswordResetError(error) {
    try {
        const ret = wasm.isEnrollAdminPasswordResetError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCryptoClientError(error) {
    try {
        const ret = wasm.isCryptoClientError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isStatefulCryptoError(error) {
    try {
        const ret = wasm.isStatefulCryptoError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEncryptionSettingsError(error) {
    try {
        const ret = wasm.isEncryptionSettingsError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCryptoError(error) {
    try {
        const ret = wasm.isCryptoError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    const mem = getDataViewMemory0();
    for (let i = 0; i < array.length; i++) {
        mem.setUint32(ptr + 4 * i, addHeapObject(array[i]), true);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}
/**
 * @param {any} error
 * @returns {boolean}
 */
export function isExportError(error) {
    try {
        const ret = wasm.isExportError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isPasswordError(error) {
    try {
        const ret = wasm.isPasswordError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isUsernameError(error) {
    try {
        const ret = wasm.isUsernameError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isTypedReceiveError(error) {
    try {
        const ret = wasm.isTypedReceiveError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isReceiveError(error) {
    try {
        const ret = wasm.isReceiveError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isSubscribeError(error) {
    try {
        const ret = wasm.isSubscribeError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isRequestError(error) {
    try {
        const ret = wasm.isRequestError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
}
/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDeserializeError(error) {
    try {
        const ret = wasm.isDeserializeError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isChannelError(error) {
    try {
        const ret = wasm.isChannelError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * Sends a DiscoverRequest to the specified destination and returns the response.
 * @param {IpcClient} ipc_client
 * @param {Endpoint} destination
 * @param {AbortSignal | null} [abort_signal]
 * @returns {Promise<DiscoverResponse>}
 */
export function ipcRequestDiscover(ipc_client, destination, abort_signal) {
    _assertClass(ipc_client, IpcClient);
    const ret = wasm.ipcRequestDiscover(ipc_client.__wbg_ptr, addHeapObject(destination), isLikeNone(abort_signal) ? 0 : addHeapObject(abort_signal));
    return takeObject(ret);
}

/**
 * Registers a DiscoverHandler so that the client can respond to DiscoverRequests.
 * @param {IpcClient} ipc_client
 * @param {DiscoverResponse} response
 * @returns {Promise<void>}
 */
export function ipcRegisterDiscoverHandler(ipc_client, response) {
    _assertClass(ipc_client, IpcClient);
    const ret = wasm.ipcRegisterDiscoverHandler(ipc_client.__wbg_ptr, addHeapObject(response));
    return takeObject(ret);
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isServerCommunicationConfigRepositoryError(error) {
    try {
        const ret = wasm.isServerCommunicationConfigRepositoryError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isAcquireCookieError(error) {
    try {
        const ret = wasm.isAcquireCookieError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isSshKeyImportError(error) {
    try {
        const ret = wasm.isSshKeyImportError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isSshKeyExportError(error) {
    try {
        const ret = wasm.isSshKeyExportError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isKeyGenerationError(error) {
    try {
        const ret = wasm.isKeyGenerationError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDatabaseError(error) {
    try {
        const ret = wasm.isDatabaseError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isStateRegistryError(error) {
    try {
        const ret = wasm.isStateRegistryError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCallError(error) {
    try {
        const ret = wasm.isCallError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isRotateUserKeysError(error) {
    try {
        const ret = wasm.isRotateUserKeysError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isSyncError(error) {
    try {
        const ret = wasm.isSyncError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isPrivateKeysParsingError(error) {
    try {
        const ret = wasm.isPrivateKeysParsingError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCipherRiskError(error) {
    try {
        const ret = wasm.isCipherRiskError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isTotpError(error) {
    try {
        const ret = wasm.isTotpError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEncryptError(error) {
    try {
        const ret = wasm.isEncryptError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDecryptError(error) {
    try {
        const ret = wasm.isDecryptError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isGetCipherError(error) {
    try {
        const ret = wasm.isGetCipherError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEditCipherError(error) {
    try {
        const ret = wasm.isEditCipherError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isGetOrganizationCiphersAdminError(error) {
    try {
        const ret = wasm.isGetOrganizationCiphersAdminError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEditCipherAdminError(error) {
    try {
        const ret = wasm.isEditCipherAdminError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCreateCipherAdminError(error) {
    try {
        const ret = wasm.isCreateCipherAdminError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDeleteCipherAdminError(error) {
    try {
        const ret = wasm.isDeleteCipherAdminError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isRestoreCipherAdminError(error) {
    try {
        const ret = wasm.isRestoreCipherAdminError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCreateCipherError(error) {
    try {
        const ret = wasm.isCreateCipherError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDeleteCipherError(error) {
    try {
        const ret = wasm.isDeleteCipherError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isRestoreCipherError(error) {
    try {
        const ret = wasm.isRestoreCipherError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEncryptFileError(error) {
    try {
        const ret = wasm.isEncryptFileError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDecryptFileError(error) {
    try {
        const ret = wasm.isDecryptFileError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCipherError(error) {
    try {
        const ret = wasm.isCipherError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEditFolderError(error) {
    try {
        const ret = wasm.isEditFolderError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCreateFolderError(error) {
    try {
        const ret = wasm.isCreateFolderError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isGetFolderError(error) {
    try {
        const ret = wasm.isGetFolderError(addBorrowedObject(error));
        return ret !== 0;
    } finally {
        heap[stack_pointer++] = undefined;
    }
}

function wasm_bindgen__convert__closures_____invoke__h7c6e0808d83e1743(arg0, arg1) {
    wasm.wasm_bindgen__convert__closures_____invoke__h7c6e0808d83e1743(arg0, arg1);
}

function wasm_bindgen__convert__closures_____invoke__h50b4f01e700bd46b(arg0, arg1, arg2) {
    wasm.wasm_bindgen__convert__closures_____invoke__h50b4f01e700bd46b(arg0, arg1, addHeapObject(arg2));
}

function wasm_bindgen__convert__closures_____invoke__h7dd86ab58fba945e(arg0, arg1, arg2) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.wasm_bindgen__convert__closures_____invoke__h7dd86ab58fba945e(retptr, arg0, arg1, addHeapObject(arg2));
        var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
        var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
        if (r1) {
            throw takeObject(r0);
        }
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

function wasm_bindgen__convert__closures_____invoke__hc4d57ad329cc6f58(arg0, arg1, arg2, arg3) {
    wasm.wasm_bindgen__convert__closures_____invoke__hc4d57ad329cc6f58(arg0, arg1, addHeapObject(arg2), addHeapObject(arg3));
}

/**
 * @enum {300 | 301 | 302 | 303 | 304 | 305}
 */
export const CardLinkedIdType = Object.freeze({
    CardholderName: 300, "300": "CardholderName",
    ExpMonth: 301, "301": "ExpMonth",
    ExpYear: 302, "302": "ExpYear",
    Code: 303, "303": "Code",
    Brand: 304, "304": "Brand",
    Number: 305, "305": "Number",
});
/**
 * @enum {0 | 1}
 */
export const CipherRepromptType = Object.freeze({
    None: 0, "0": "None",
    Password: 1, "1": "Password",
});
/**
 * @enum {1 | 2 | 3 | 4 | 5}
 */
export const CipherType = Object.freeze({
    Login: 1, "1": "Login",
    SecureNote: 2, "2": "SecureNote",
    Card: 3, "3": "Card",
    Identity: 4, "4": "Identity",
    SshKey: 5, "5": "SshKey",
});
/**
 * Represents the type of a [FieldView].
 * @enum {0 | 1 | 2 | 3}
 */
export const FieldType = Object.freeze({
    /**
     * Text field
     */
    Text: 0, "0": "Text",
    /**
     * Hidden text field
     */
    Hidden: 1, "1": "Hidden",
    /**
     * Boolean field
     */
    Boolean: 2, "2": "Boolean",
    /**
     * Linked field
     */
    Linked: 3, "3": "Linked",
});
/**
 * @enum {400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418}
 */
export const IdentityLinkedIdType = Object.freeze({
    Title: 400, "400": "Title",
    MiddleName: 401, "401": "MiddleName",
    Address1: 402, "402": "Address1",
    Address2: 403, "403": "Address2",
    Address3: 404, "404": "Address3",
    City: 405, "405": "City",
    State: 406, "406": "State",
    PostalCode: 407, "407": "PostalCode",
    Country: 408, "408": "Country",
    Company: 409, "409": "Company",
    Email: 410, "410": "Email",
    Phone: 411, "411": "Phone",
    Ssn: 412, "412": "Ssn",
    Username: 413, "413": "Username",
    PassportNumber: 414, "414": "PassportNumber",
    LicenseNumber: 415, "415": "LicenseNumber",
    FirstName: 416, "416": "FirstName",
    LastName: 417, "417": "LastName",
    FullName: 418, "418": "FullName",
});
/**
 * @enum {0 | 1 | 2 | 3 | 4}
 */
export const LogLevel = Object.freeze({
    Trace: 0, "0": "Trace",
    Debug: 1, "1": "Debug",
    Info: 2, "2": "Info",
    Warn: 3, "3": "Warn",
    Error: 4, "4": "Error",
});
/**
 * @enum {100 | 101}
 */
export const LoginLinkedIdType = Object.freeze({
    Username: 100, "100": "Username",
    Password: 101, "101": "Password",
});
/**
 * @enum {0 | 1 | 2 | 3}
 */
export const RsaError = Object.freeze({
    Decryption: 0, "0": "Decryption",
    Encryption: 1, "1": "Encryption",
    KeyParse: 2, "2": "KeyParse",
    KeySerialize: 3, "3": "KeySerialize",
});
/**
 * @enum {0}
 */
export const SecureNoteType = Object.freeze({
    Generic: 0, "0": "Generic",
});
/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5}
 */
export const UriMatchType = Object.freeze({
    Domain: 0, "0": "Domain",
    Host: 1, "1": "Host",
    StartsWith: 2, "2": "StartsWith",
    Exact: 3, "3": "Exact",
    RegularExpression: 4, "4": "RegularExpression",
    Never: 5, "5": "Never",
});

const __wbindgen_enum_IdbTransactionMode = ["readonly", "readwrite", "versionchange", "readwriteflush", "cleanup"];

const __wbindgen_enum_RequestCache = ["default", "no-store", "reload", "no-cache", "force-cache", "only-if-cached"];

const __wbindgen_enum_RequestCredentials = ["omit", "same-origin", "include"];

const __wbindgen_enum_RequestMode = ["same-origin", "no-cors", "cors", "navigate"];

const AttachmentsClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_attachmentsclient_free(ptr >>> 0, 1));

export class AttachmentsClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AttachmentsClient.prototype);
        obj.__wbg_ptr = ptr;
        AttachmentsClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AttachmentsClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_attachmentsclient_free(ptr, 0);
    }
    /**
     * @param {Cipher} cipher
     * @param {AttachmentView} attachment
     * @param {Uint8Array} encrypted_buffer
     * @returns {Uint8Array}
     */
    decrypt_buffer(cipher, attachment, encrypted_buffer) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(encrypted_buffer, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.attachmentsclient_decrypt_buffer(retptr, this.__wbg_ptr, addHeapObject(cipher), addHeapObject(attachment), ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) AttachmentsClient.prototype[Symbol.dispose] = AttachmentsClient.prototype.free;

const AuthClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_authclient_free(ptr >>> 0, 1));
/**
 * Subclient containing auth functionality.
 */
export class AuthClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(AuthClient.prototype);
        obj.__wbg_ptr = ptr;
        AuthClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AuthClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_authclient_free(ptr, 0);
    }
    /**
     * Client for send access functionality
     * @returns {SendAccessClient}
     */
    send_access() {
        const ret = wasm.authclient_registration(this.__wbg_ptr);
        return SendAccessClient.__wrap(ret);
    }
    /**
     * Client for initializing user account cryptography and unlock methods after JIT provisioning
     * @returns {RegistrationClient}
     */
    registration() {
        const ret = wasm.authclient_registration(this.__wbg_ptr);
        return RegistrationClient.__wrap(ret);
    }
    /**
     * Client for login functionality
     * @param {ClientSettings} client_settings
     * @returns {LoginClient}
     */
    login(client_settings) {
        const ret = wasm.authclient_login(this.__wbg_ptr, addHeapObject(client_settings));
        return LoginClient.__wrap(ret);
    }
}
if (Symbol.dispose) AuthClient.prototype[Symbol.dispose] = AuthClient.prototype.free;

const CipherAdminClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cipheradminclient_free(ptr >>> 0, 1));
/**
 * Client for performing admin operations on ciphers. Unlike the regular CiphersClient,
 * this client uses the admin server API endpoints, and does not modify local state.
 */
export class CipherAdminClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CipherAdminClient.prototype);
        obj.__wbg_ptr = ptr;
        CipherAdminClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CipherAdminClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cipheradminclient_free(ptr, 0);
    }
    /**
     * @param {OrganizationId} org_id
     * @param {boolean} include_member_items
     * @returns {Promise<DecryptCipherListResult>}
     */
    list_org_ciphers(org_id, include_member_items) {
        const ret = wasm.cipheradminclient_list_org_ciphers(this.__wbg_ptr, addHeapObject(org_id), include_member_items);
        return takeObject(ret);
    }
    /**
     * Adds the cipher matched by [CipherId] to any number of collections on the server.
     * @param {CipherId} cipher_id
     * @param {CollectionId[]} collection_ids
     * @returns {Promise<CipherView>}
     */
    update_collection(cipher_id, collection_ids) {
        const ptr0 = passArrayJsValueToWasm0(collection_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cipheradminclient_update_collection(this.__wbg_ptr, addHeapObject(cipher_id), ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Edit an existing [Cipher] and save it to the server.
     * @param {CipherEditRequest} request
     * @param {CipherView} original_cipher_view
     * @returns {Promise<CipherView>}
     */
    edit(request, original_cipher_view) {
        const ret = wasm.cipheradminclient_edit(this.__wbg_ptr, addHeapObject(request), addHeapObject(original_cipher_view));
        return takeObject(ret);
    }
    /**
     * Creates a new [Cipher] for an organization, using the admin server endpoints.
     * Creates the Cipher on the server only, does not store it to local state.
     * @param {CipherCreateRequest} request
     * @returns {Promise<CipherView>}
     */
    create(request) {
        const ret = wasm.cipheradminclient_create(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Deletes all Cipher objects with a matching CipherId from the server, using the admin
     * endpoint. Affects server data only, does not modify local state.
     * @param {CipherId[]} cipher_ids
     * @param {OrganizationId} organization_id
     * @returns {Promise<void>}
     */
    delete_many(cipher_ids, organization_id) {
        const ptr0 = passArrayJsValueToWasm0(cipher_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cipheradminclient_delete_many(this.__wbg_ptr, ptr0, len0, addHeapObject(organization_id));
        return takeObject(ret);
    }
    /**
     * Soft-deletes the Cipher with the matching CipherId from the server, using the admin
     * endpoint. Affects server data only, does not modify local state.
     * @param {CipherId} cipher_id
     * @returns {Promise<void>}
     */
    soft_delete(cipher_id) {
        const ret = wasm.cipheradminclient_soft_delete(this.__wbg_ptr, addHeapObject(cipher_id));
        return takeObject(ret);
    }
    /**
     * Soft-deletes all Cipher objects for the given CipherIds from the server, using the admin
     * endpoint. Affects server data only, does not modify local state.
     * @param {CipherId[]} cipher_ids
     * @param {OrganizationId} organization_id
     * @returns {Promise<void>}
     */
    soft_delete_many(cipher_ids, organization_id) {
        const ptr0 = passArrayJsValueToWasm0(cipher_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cipheradminclient_soft_delete_many(this.__wbg_ptr, ptr0, len0, addHeapObject(organization_id));
        return takeObject(ret);
    }
    /**
     * Deletes the Cipher with the matching CipherId from the server, using the admin endpoint.
     * Affects server data only, does not modify local state.
     * @param {CipherId} cipher_id
     * @returns {Promise<void>}
     */
    delete(cipher_id) {
        const ret = wasm.cipheradminclient_delete(this.__wbg_ptr, addHeapObject(cipher_id));
        return takeObject(ret);
    }
    /**
     * Restores multiple soft-deleted ciphers on the server.
     * @param {CipherId[]} cipher_ids
     * @param {OrganizationId} org_id
     * @returns {Promise<DecryptCipherListResult>}
     */
    restore_many(cipher_ids, org_id) {
        const ptr0 = passArrayJsValueToWasm0(cipher_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cipheradminclient_restore_many(this.__wbg_ptr, ptr0, len0, addHeapObject(org_id));
        return takeObject(ret);
    }
    /**
     * Restores a soft-deleted cipher on the server, using the admin endpoint.
     * @param {CipherId} cipher_id
     * @returns {Promise<CipherView>}
     */
    restore(cipher_id) {
        const ret = wasm.cipheradminclient_restore(this.__wbg_ptr, addHeapObject(cipher_id));
        return takeObject(ret);
    }
}
if (Symbol.dispose) CipherAdminClient.prototype[Symbol.dispose] = CipherAdminClient.prototype.free;

const CipherRiskClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cipherriskclient_free(ptr >>> 0, 1));
/**
 * Client for evaluating credential risk for login ciphers.
 */
export class CipherRiskClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CipherRiskClient.prototype);
        obj.__wbg_ptr = ptr;
        CipherRiskClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CipherRiskClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cipherriskclient_free(ptr, 0);
    }
    /**
     * Evaluate security risks for multiple login ciphers concurrently.
     *
     * For each cipher:
     * 1. Calculates password strength (0-4) using zxcvbn with cipher-specific context
     * 2. Optionally checks if the password has been exposed via Have I Been Pwned API
     * 3. Counts how many times the password is reused in the provided `password_map`
     *
     * Returns a vector of `CipherRisk` results, one for each input cipher.
     *
     * ## HIBP Check Results (`exposed_result` field)
     *
     * The `exposed_result` field uses the `ExposedPasswordResult` enum with three possible states:
     * - `NotChecked`: Password exposure check was not performed because:
     *   - `check_exposed` option was `false`, or
     *   - Password was empty
     * - `Found(n)`: Successfully checked via HIBP API, password appears in `n` data breaches
     * - `Error(msg)`: HIBP API request failed with error message `msg`
     *
     * # Errors
     *
     * This method only returns `Err` for internal logic failures. HIBP API errors are
     * captured per-cipher in the `exposed_result` field as `ExposedPasswordResult::Error(msg)`.
     * @param {CipherLoginDetails[]} login_details
     * @param {CipherRiskOptions} options
     * @returns {Promise<CipherRiskResult[]>}
     */
    compute_risk(login_details, options) {
        const ptr0 = passArrayJsValueToWasm0(login_details, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cipherriskclient_compute_risk(this.__wbg_ptr, ptr0, len0, addHeapObject(options));
        return takeObject(ret);
    }
    /**
     * Build password reuse map for a list of login ciphers.
     *
     * Returns a map where keys are passwords and values are the number of times
     * each password appears in the provided list. This map can be passed to `compute_risk()`
     * to enable password reuse detection.
     * @param {CipherLoginDetails[]} login_details
     * @returns {PasswordReuseMap}
     */
    password_reuse_map(login_details) {
        const ptr0 = passArrayJsValueToWasm0(login_details, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.cipherriskclient_password_reuse_map(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
}
if (Symbol.dispose) CipherRiskClient.prototype[Symbol.dispose] = CipherRiskClient.prototype.free;

const CiphersClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ciphersclient_free(ptr >>> 0, 1));

export class CiphersClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CiphersClient.prototype);
        obj.__wbg_ptr = ptr;
        CiphersClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CiphersClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ciphersclient_free(ptr, 0);
    }
    /**
     * Moves a cipher into an organization, adds it to collections, and calls the share_cipher API.
     * @param {CipherView} cipher_view
     * @param {OrganizationId} organization_id
     * @param {CollectionId[]} collection_ids
     * @param {Cipher | null} [original_cipher]
     * @returns {Promise<Cipher>}
     */
    share_cipher(cipher_view, organization_id, collection_ids, original_cipher) {
        const ptr0 = passArrayJsValueToWasm0(collection_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_share_cipher(this.__wbg_ptr, addHeapObject(cipher_view), addHeapObject(organization_id), ptr0, len0, isLikeNone(original_cipher) ? 0 : addHeapObject(original_cipher));
        return takeObject(ret);
    }
    /**
     * Moves a group of ciphers into an organization, adds them to collections, and calls the
     * share_ciphers API.
     * @param {CipherView[]} cipher_views
     * @param {OrganizationId} organization_id
     * @param {CollectionId[]} collection_ids
     * @returns {Promise<Cipher[]>}
     */
    share_ciphers_bulk(cipher_views, organization_id, collection_ids) {
        const ptr0 = passArrayJsValueToWasm0(cipher_views, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(collection_ids, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_share_ciphers_bulk(this.__wbg_ptr, ptr0, len0, addHeapObject(organization_id), ptr1, len1);
        return takeObject(ret);
    }
    /**
     * @param {Cipher[]} ciphers
     * @returns {CipherListView[]}
     */
    decrypt_list(ciphers) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(ciphers, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ciphersclient_decrypt_list(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Encrypt a list of cipher views.
     *
     * This method attempts to encrypt all ciphers in the list. If any cipher
     * fails to encrypt, the entire operation fails and an error is returned.
     * @param {CipherView[]} cipher_views
     * @returns {EncryptionContext[]}
     */
    encrypt_list(cipher_views) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(cipher_views, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ciphersclient_encrypt_list(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {CipherView} cipher_view
     * @param {OrganizationId} organization_id
     * @returns {CipherView}
     */
    move_to_organization(cipher_view, organization_id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ciphersclient_move_to_organization(retptr, this.__wbg_ptr, addHeapObject(cipher_view), addHeapObject(organization_id));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Temporary method used to re-encrypt FIDO2 credentials for a cipher view.
     * Necessary until the TS clients utilize the SDK entirely for FIDO2 credentials management.
     * TS clients create decrypted FIDO2 credentials that need to be encrypted manually when
     * encrypting the rest of the CipherView.
     * TODO: Remove once TS passkey provider implementation uses SDK - PM-8313
     * @param {CipherView} cipher_view
     * @param {Fido2CredentialFullView[]} fido2_credentials
     * @returns {CipherView}
     */
    set_fido2_credentials(cipher_view, fido2_credentials) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(fido2_credentials, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.ciphersclient_set_fido2_credentials(retptr, this.__wbg_ptr, addHeapObject(cipher_view), ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {CipherView} cipher_view
     * @returns {Fido2CredentialView[]}
     */
    decrypt_fido2_credentials(cipher_view) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ciphersclient_decrypt_fido2_credentials(retptr, this.__wbg_ptr, addHeapObject(cipher_view));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {CipherView} cipher_view
     * @returns {string}
     */
    decrypt_fido2_private_key(cipher_view) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ciphersclient_decrypt_fido2_private_key(retptr, this.__wbg_ptr, addHeapObject(cipher_view));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * Decrypt cipher list with failures
     * Returns both successfully decrypted ciphers and any that failed to decrypt
     * @param {Cipher[]} ciphers
     * @returns {DecryptCipherListResult}
     */
    decrypt_list_with_failures(ciphers) {
        const ptr0 = passArrayJsValueToWasm0(ciphers, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_decrypt_list_with_failures(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Encrypt a cipher with the provided key. This should only be used when rotating encryption
     * keys in the Web client.
     *
     * Until key rotation is fully implemented in the SDK, this method must be provided the new
     * symmetric key in base64 format. See PM-23084
     *
     * If the cipher has a CipherKey, it will be re-encrypted with the new key.
     * If the cipher does not have a CipherKey and CipherKeyEncryption is enabled, one will be
     * generated using the new key. Otherwise, the cipher's data will be encrypted with the new
     * key directly.
     * @param {CipherView} cipher_view
     * @param {B64} new_key
     * @returns {EncryptionContext}
     */
    encrypt_cipher_for_rotation(cipher_view, new_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ciphersclient_encrypt_cipher_for_rotation(retptr, this.__wbg_ptr, addHeapObject(cipher_view), addHeapObject(new_key));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Decrypt full cipher list
     * Returns both successfully fully decrypted ciphers and any that failed to decrypt
     * @param {Cipher[]} ciphers
     * @returns {DecryptCipherResult}
     */
    decrypt_list_full_with_failures(ciphers) {
        const ptr0 = passArrayJsValueToWasm0(ciphers, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_decrypt_list_full_with_failures(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Returns a new client for performing admin operations.
     * Uses the admin server API endpoints and does not modify local state.
     * @returns {CipherAdminClient}
     */
    admin() {
        const ret = wasm.ciphersclient_admin(this.__wbg_ptr);
        return CipherAdminClient.__wrap(ret);
    }
    /**
     * @param {Cipher} cipher
     * @returns {CipherView}
     */
    decrypt(cipher) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ciphersclient_decrypt(retptr, this.__wbg_ptr, addHeapObject(cipher));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {CipherView} cipher_view
     * @returns {EncryptionContext}
     */
    encrypt(cipher_view) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.ciphersclient_encrypt(retptr, this.__wbg_ptr, addHeapObject(cipher_view));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Get [Cipher] by ID from state and decrypt it to a [CipherView].
     * @param {string} cipher_id
     * @returns {Promise<CipherView>}
     */
    get(cipher_id) {
        const ptr0 = passStringToWasm0(cipher_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_get(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Get all ciphers from state and decrypt them, returning both successes and failures.
     * This method will not fail when some ciphers fail to decrypt, allowing for graceful
     * handling of corrupted or problematic cipher data.
     * @returns {Promise<DecryptCipherListResult>}
     */
    list() {
        const ret = wasm.ciphersclient_list(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * Adds the cipher matched by [CipherId] to any number of collections on the server.
     * @param {CipherId} cipher_id
     * @param {CollectionId[]} collection_ids
     * @param {boolean} is_admin
     * @returns {Promise<CipherView>}
     */
    update_collection(cipher_id, collection_ids, is_admin) {
        const ptr0 = passArrayJsValueToWasm0(collection_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_update_collection(this.__wbg_ptr, addHeapObject(cipher_id), ptr0, len0, is_admin);
        return takeObject(ret);
    }
    /**
     * Edit an existing [Cipher] and save it to the server.
     * @param {CipherEditRequest} request
     * @returns {Promise<CipherView>}
     */
    edit(request) {
        const ret = wasm.ciphersclient_edit(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Creates a new [Cipher] and saves it to the server.
     * @param {CipherCreateRequest} request
     * @returns {Promise<CipherView>}
     */
    create(request) {
        const ret = wasm.ciphersclient_create(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Deletes all [Cipher] objects with a matching [CipherId] from the server.
     * @param {CipherId[]} cipher_ids
     * @param {OrganizationId | null} [organization_id]
     * @returns {Promise<void>}
     */
    delete_many(cipher_ids, organization_id) {
        const ptr0 = passArrayJsValueToWasm0(cipher_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_delete_many(this.__wbg_ptr, ptr0, len0, isLikeNone(organization_id) ? 0 : addHeapObject(organization_id));
        return takeObject(ret);
    }
    /**
     * Soft-deletes the [Cipher] with the matching [CipherId] from the server.
     * @param {CipherId} cipher_id
     * @returns {Promise<void>}
     */
    soft_delete(cipher_id) {
        const ret = wasm.ciphersclient_soft_delete(this.__wbg_ptr, addHeapObject(cipher_id));
        return takeObject(ret);
    }
    /**
     * Soft-deletes all [Cipher] objects for the given [CipherId]s from the server.
     * @param {CipherId[]} cipher_ids
     * @param {OrganizationId | null} [organization_id]
     * @returns {Promise<void>}
     */
    soft_delete_many(cipher_ids, organization_id) {
        const ptr0 = passArrayJsValueToWasm0(cipher_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_soft_delete_many(this.__wbg_ptr, ptr0, len0, isLikeNone(organization_id) ? 0 : addHeapObject(organization_id));
        return takeObject(ret);
    }
    /**
     * Deletes the [Cipher] with the matching [CipherId] from the server.
     * @param {CipherId} cipher_id
     * @returns {Promise<void>}
     */
    delete(cipher_id) {
        const ret = wasm.ciphersclient_delete(this.__wbg_ptr, addHeapObject(cipher_id));
        return takeObject(ret);
    }
    /**
     * Restores multiple soft-deleted ciphers on the server.
     * @param {CipherId[]} cipher_ids
     * @returns {Promise<DecryptCipherListResult>}
     */
    restore_many(cipher_ids) {
        const ptr0 = passArrayJsValueToWasm0(cipher_ids, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.ciphersclient_restore_many(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Restores a soft-deleted cipher on the server.
     * @param {CipherId} cipher_id
     * @returns {Promise<CipherView>}
     */
    restore(cipher_id) {
        const ret = wasm.ciphersclient_restore(this.__wbg_ptr, addHeapObject(cipher_id));
        return takeObject(ret);
    }
}
if (Symbol.dispose) CiphersClient.prototype[Symbol.dispose] = CiphersClient.prototype.free;

const CollectionViewNodeItemFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_collectionviewnodeitem_free(ptr >>> 0, 1));

export class CollectionViewNodeItem {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CollectionViewNodeItem.prototype);
        obj.__wbg_ptr = ptr;
        CollectionViewNodeItemFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CollectionViewNodeItemFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_collectionviewnodeitem_free(ptr, 0);
    }
    /**
     * @returns {CollectionView | undefined}
     */
    get_parent() {
        const ret = wasm.collectionviewnodeitem_get_parent(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {CollectionView[]}
     */
    get_children() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.collectionviewnodeitem_get_children(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {AncestorMap}
     */
    get_ancestors() {
        const ret = wasm.collectionviewnodeitem_get_ancestors(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {CollectionView}
     */
    get_item() {
        const ret = wasm.collectionviewnodeitem_get_item(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) CollectionViewNodeItem.prototype[Symbol.dispose] = CollectionViewNodeItem.prototype.free;

const CollectionViewTreeFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_collectionviewtree_free(ptr >>> 0, 1));

export class CollectionViewTree {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CollectionViewTree.prototype);
        obj.__wbg_ptr = ptr;
        CollectionViewTreeFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CollectionViewTreeFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_collectionviewtree_free(ptr, 0);
    }
    /**
     * @returns {CollectionViewNodeItem[]}
     */
    get_flat_items() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.collectionviewtree_get_flat_items(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {CollectionViewNodeItem[]}
     */
    get_root_items() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.collectionviewtree_get_root_items(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {CollectionView} collection_view
     * @returns {CollectionViewNodeItem | undefined}
     */
    get_item_for_view(collection_view) {
        const ret = wasm.collectionviewtree_get_item_for_view(this.__wbg_ptr, addHeapObject(collection_view));
        return ret === 0 ? undefined : CollectionViewNodeItem.__wrap(ret);
    }
}
if (Symbol.dispose) CollectionViewTree.prototype[Symbol.dispose] = CollectionViewTree.prototype.free;

const CollectionsClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_collectionsclient_free(ptr >>> 0, 1));

export class CollectionsClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CollectionsClient.prototype);
        obj.__wbg_ptr = ptr;
        CollectionsClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CollectionsClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_collectionsclient_free(ptr, 0);
    }
    /**
     * @param {Collection[]} collections
     * @returns {CollectionView[]}
     */
    decrypt_list(collections) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(collections, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.collectionsclient_decrypt_list(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     *
     * Returns the vector of CollectionView objects in a tree structure based on its implemented
     * path().
     * @param {CollectionView[]} collections
     * @returns {CollectionViewTree}
     */
    get_collection_tree(collections) {
        const ptr0 = passArrayJsValueToWasm0(collections, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.collectionsclient_get_collection_tree(this.__wbg_ptr, ptr0, len0);
        return CollectionViewTree.__wrap(ret);
    }
    /**
     * @param {Collection} collection
     * @returns {CollectionView}
     */
    decrypt(collection) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.collectionsclient_decrypt(retptr, this.__wbg_ptr, addHeapObject(collection));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) CollectionsClient.prototype[Symbol.dispose] = CollectionsClient.prototype.free;

const CommercialPasswordManagerClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_commercialpasswordmanagerclient_free(ptr >>> 0, 1));
/**
 * Client for bitwarden licensed operations
 */
export class CommercialPasswordManagerClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CommercialPasswordManagerClient.prototype);
        obj.__wbg_ptr = ptr;
        CommercialPasswordManagerClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CommercialPasswordManagerClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_commercialpasswordmanagerclient_free(ptr, 0);
    }
    /**
     * Vault item operations
     * @returns {CommercialVaultClient}
     */
    vault() {
        const ret = wasm.commercialpasswordmanagerclient_vault(this.__wbg_ptr);
        return CommercialVaultClient.__wrap(ret);
    }
}
if (Symbol.dispose) CommercialPasswordManagerClient.prototype[Symbol.dispose] = CommercialPasswordManagerClient.prototype.free;

const CommercialVaultClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_commercialvaultclient_free(ptr >>> 0, 1));

export class CommercialVaultClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CommercialVaultClient.prototype);
        obj.__wbg_ptr = ptr;
        CommercialVaultClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CommercialVaultClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_commercialvaultclient_free(ptr, 0);
    }
}
if (Symbol.dispose) CommercialVaultClient.prototype[Symbol.dispose] = CommercialVaultClient.prototype.free;

const CryptoClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_cryptoclient_free(ptr >>> 0, 1));
/**
 * A client for the crypto operations.
 */
export class CryptoClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(CryptoClient.prototype);
        obj.__wbg_ptr = ptr;
        CryptoClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        CryptoClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_cryptoclient_free(ptr, 0);
    }
    /**
     * Protects the current user key with the provided PIN. The result can be stored and later
     * used to initialize another client instance by using the PIN and the PIN key with
     * `initialize_user_crypto`.
     * @param {string} pin
     * @returns {EnrollPinResponse}
     */
    enroll_pin(pin) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(pin, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cryptoclient_enroll_pin(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Generates a new key pair and encrypts the private key with the provided user key.
     * Crypto initialization not required.
     * @param {B64} user_key
     * @returns {MakeKeyPairResponse}
     */
    make_key_pair(user_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cryptoclient_make_key_pair(retptr, this.__wbg_ptr, addHeapObject(user_key));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Create the data necessary to update the user's kdf settings. The user's encryption key is
     * re-encrypted for the password under the new kdf settings. This returns the re-encrypted
     * user key and the new password hash but does not update sdk state.
     * @param {string} password
     * @param {Kdf} kdf
     * @returns {UpdateKdfResponse}
     */
    make_update_kdf(password, kdf) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cryptoclient_make_update_kdf(retptr, this.__wbg_ptr, ptr0, len0, addHeapObject(kdf));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Initialization method for the organization crypto. Needs to be called after
     * `initialize_user_crypto` but before any other crypto operations.
     * @param {InitOrgCryptoRequest} req
     * @returns {Promise<void>}
     */
    initialize_org_crypto(req) {
        const ret = wasm.cryptoclient_initialize_org_crypto(this.__wbg_ptr, addHeapObject(req));
        return takeObject(ret);
    }
    /**
     * Initialization method for the user crypto. Needs to be called before any other crypto
     * operations.
     * @param {InitUserCryptoRequest} req
     * @returns {Promise<void>}
     */
    initialize_user_crypto(req) {
        const ret = wasm.cryptoclient_initialize_user_crypto(this.__wbg_ptr, addHeapObject(req));
        return takeObject(ret);
    }
    /**
     * Verifies a user's asymmetric keys by decrypting the private key with the provided user
     * key. Returns if the private key is decryptable and if it is a valid matching key.
     * Crypto initialization not required.
     * @param {VerifyAsymmetricKeysRequest} request
     * @returns {VerifyAsymmetricKeysResponse}
     */
    verify_asymmetric_keys(request) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cryptoclient_verify_asymmetric_keys(retptr, this.__wbg_ptr, addHeapObject(request));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Creates a rotated set of account keys for the current state
     * @returns {UserCryptoV2KeysResponse}
     */
    get_v2_rotated_account_keys() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cryptoclient_get_v2_rotated_account_keys(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Makes a new signing key pair and signs the public key for the user
     * @returns {UserCryptoV2KeysResponse}
     */
    make_keys_for_user_crypto_v2() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.cryptoclient_make_keys_for_user_crypto_v2(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Protects the current user key with the provided PIN. The result can be stored and later
     * used to initialize another client instance by using the PIN and the PIN key with
     * `initialize_user_crypto`. The provided pin is encrypted with the user key.
     * @param {string} encrypted_pin
     * @returns {EnrollPinResponse}
     */
    enroll_pin_with_encrypted_pin(encrypted_pin) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(encrypted_pin, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.cryptoclient_enroll_pin_with_encrypted_pin(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Decrypts a `PasswordProtectedKeyEnvelope`, returning the user key, if successful.
     * This is a stop-gap solution, until initialization of the SDK is used.
     * @param {string} pin
     * @param {string} envelope
     * @returns {Uint8Array}
     */
    unseal_password_protected_key_envelope(pin, envelope) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(pin, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(envelope, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.cryptoclient_unseal_password_protected_key_envelope(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) CryptoClient.prototype[Symbol.dispose] = CryptoClient.prototype.free;

const ExporterClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_exporterclient_free(ptr >>> 0, 1));

export class ExporterClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ExporterClient.prototype);
        obj.__wbg_ptr = ptr;
        ExporterClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ExporterClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_exporterclient_free(ptr, 0);
    }
    /**
     * Credential Exchange Format (CXF)
     *
     * *Warning:* Expect this API to be unstable, and it will change in the future.
     *
     * For use with Apple using [ASCredentialExportManager](https://developer.apple.com/documentation/authenticationservices/ascredentialexportmanager).
     * Ideally, the input should be immediately serialized from [ASImportableAccount](https://developer.apple.com/documentation/authenticationservices/asimportableaccount).
     * @param {Account} account
     * @param {Cipher[]} ciphers
     * @returns {string}
     */
    export_cxf(account, ciphers) {
        let deferred3_0;
        let deferred3_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(ciphers, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exporterclient_export_cxf(retptr, this.__wbg_ptr, addHeapObject(account), ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr2 = r0;
            var len2 = r1;
            if (r3) {
                ptr2 = 0; len2 = 0;
                throw takeObject(r2);
            }
            deferred3_0 = ptr2;
            deferred3_1 = len2;
            return getStringFromWasm0(ptr2, len2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred3_0, deferred3_1, 1);
        }
    }
    /**
     * Credential Exchange Format (CXF)
     *
     * *Warning:* Expect this API to be unstable, and it will change in the future.
     *
     * For use with Apple using [ASCredentialExportManager](https://developer.apple.com/documentation/authenticationservices/ascredentialexportmanager).
     * Ideally, the input should be immediately serialized from [ASImportableAccount](https://developer.apple.com/documentation/authenticationservices/asimportableaccount).
     * @param {string} payload
     * @returns {Cipher[]}
     */
    import_cxf(payload) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(payload, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.exporterclient_import_cxf(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {Folder[]} folders
     * @param {Cipher[]} ciphers
     * @param {ExportFormat} format
     * @returns {string}
     */
    export_vault(folders, ciphers, format) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(folders, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArrayJsValueToWasm0(ciphers, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.exporterclient_export_vault(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, addHeapObject(format));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {Collection[]} collections
     * @param {Cipher[]} ciphers
     * @param {ExportFormat} format
     * @returns {string}
     */
    export_organization_vault(collections, ciphers, format) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(collections, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArrayJsValueToWasm0(ciphers, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.exporterclient_export_organization_vault(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, addHeapObject(format));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
}
if (Symbol.dispose) ExporterClient.prototype[Symbol.dispose] = ExporterClient.prototype.free;

const FoldersClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_foldersclient_free(ptr >>> 0, 1));
/**
 * Wrapper for folder specific functionality.
 */
export class FoldersClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FoldersClient.prototype);
        obj.__wbg_ptr = ptr;
        FoldersClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FoldersClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_foldersclient_free(ptr, 0);
    }
    /**
     * Decrypt a list of [Folder]s to a list of [FolderView]s.
     * @param {Folder[]} folders
     * @returns {FolderView[]}
     */
    decrypt_list(folders) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArrayJsValueToWasm0(folders, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.foldersclient_decrypt_list(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Get a specific [Folder] by its ID from state and decrypt it to a [FolderView].
     * @param {FolderId} folder_id
     * @returns {Promise<FolderView>}
     */
    get(folder_id) {
        const ret = wasm.foldersclient_get(this.__wbg_ptr, addHeapObject(folder_id));
        return takeObject(ret);
    }
    /**
     * Edit the [Folder] and save it to the server.
     * @param {FolderId} folder_id
     * @param {FolderAddEditRequest} request
     * @returns {Promise<FolderView>}
     */
    edit(folder_id, request) {
        const ret = wasm.foldersclient_edit(this.__wbg_ptr, addHeapObject(folder_id), addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Get all folders from state and decrypt them to a list of [FolderView].
     * @returns {Promise<FolderView[]>}
     */
    list() {
        const ret = wasm.foldersclient_list(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * Create a new [Folder] and save it to the server.
     * @param {FolderAddEditRequest} request
     * @returns {Promise<FolderView>}
     */
    create(request) {
        const ret = wasm.foldersclient_create(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Encrypt a [Folder] to [FolderView].
     * @param {Folder} folder
     * @returns {FolderView}
     */
    decrypt(folder) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.foldersclient_decrypt(retptr, this.__wbg_ptr, addHeapObject(folder));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Encrypt a [FolderView] to a [Folder].
     * @param {FolderView} folder_view
     * @returns {Folder}
     */
    encrypt(folder_view) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.foldersclient_encrypt(retptr, this.__wbg_ptr, addHeapObject(folder_view));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) FoldersClient.prototype[Symbol.dispose] = FoldersClient.prototype.free;

const GeneratorClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_generatorclient_free(ptr >>> 0, 1));

export class GeneratorClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(GeneratorClient.prototype);
        obj.__wbg_ptr = ptr;
        GeneratorClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        GeneratorClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_generatorclient_free(ptr, 0);
    }
    /**
     * Generates a random passphrase.
     * A passphrase is a combination of random words separated by a character.
     * An example of passphrase is `correct horse battery staple`.
     *
     * The number of words and their case, the word separator, and the inclusion of
     * a number in the passphrase can be customized using the `input` parameter.
     *
     * # Examples
     *
     * ```
     * use bitwarden_core::Client;
     * use bitwarden_generators::{GeneratorClientsExt, PassphraseError, PassphraseGeneratorRequest};
     *
     * async fn test() -> Result<(), PassphraseError> {
     *     let input = PassphraseGeneratorRequest {
     *         num_words: 4,
     *         ..Default::default()
     *     };
     *     let passphrase = Client::new(None).generator().passphrase(input).unwrap();
     *     println!("{}", passphrase);
     *     Ok(())
     * }
     * ```
     * @param {PassphraseGeneratorRequest} input
     * @returns {string}
     */
    passphrase(input) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.generatorclient_passphrase(retptr, this.__wbg_ptr, addHeapObject(input));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * Generates a random password.
     *
     * The character sets and password length can be customized using the `input` parameter.
     *
     * # Examples
     *
     * ```
     * use bitwarden_core::Client;
     * use bitwarden_generators::{GeneratorClientsExt, PassphraseError, PasswordGeneratorRequest};
     *
     * async fn test() -> Result<(), PassphraseError> {
     *     let input = PasswordGeneratorRequest {
     *         lowercase: true,
     *         uppercase: true,
     *         numbers: true,
     *         length: 20,
     *         ..Default::default()
     *     };
     *     let password = Client::new(None).generator().password(input).unwrap();
     *     println!("{}", password);
     *     Ok(())
     * }
     * ```
     * @param {PasswordGeneratorRequest} input
     * @returns {string}
     */
    password(input) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.generatorclient_password(retptr, this.__wbg_ptr, addHeapObject(input));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr1 = r0;
            var len1 = r1;
            if (r3) {
                ptr1 = 0; len1 = 0;
                throw takeObject(r2);
            }
            deferred2_0 = ptr1;
            deferred2_1 = len1;
            return getStringFromWasm0(ptr1, len1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
}
if (Symbol.dispose) GeneratorClient.prototype[Symbol.dispose] = GeneratorClient.prototype.free;

const IncomingMessageFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_incomingmessage_free(ptr >>> 0, 1));

export class IncomingMessage {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(IncomingMessage.prototype);
        obj.__wbg_ptr = ptr;
        IncomingMessageFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IncomingMessageFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_incomingmessage_free(ptr, 0);
    }
    /**
     * Try to parse the payload as JSON.
     * @returns {any} The parsed JSON value, or undefined if the payload is not valid JSON.
     */
    parse_payload_as_json() {
        const ret = wasm.incomingmessage_parse_payload_as_json(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {Uint8Array} payload
     * @param {Endpoint} destination
     * @param {Endpoint} source
     * @param {string | null} [topic]
     */
    constructor(payload, destination, source, topic) {
        const ptr0 = passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(topic) ? 0 : passStringToWasm0(topic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.incomingmessage_new(ptr0, len0, addHeapObject(destination), addHeapObject(source), ptr1, len1);
        this.__wbg_ptr = ret >>> 0;
        IncomingMessageFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {Uint8Array}
     */
    get payload() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_incomingmessage_payload(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {Uint8Array} arg0
     */
    set payload(arg0) {
        const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_incomingmessage_payload(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {Endpoint}
     */
    get destination() {
        const ret = wasm.__wbg_get_incomingmessage_destination(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {Endpoint} arg0
     */
    set destination(arg0) {
        wasm.__wbg_set_incomingmessage_destination(this.__wbg_ptr, addHeapObject(arg0));
    }
    /**
     * @returns {Endpoint}
     */
    get source() {
        const ret = wasm.__wbg_get_incomingmessage_source(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {Endpoint} arg0
     */
    set source(arg0) {
        wasm.__wbg_set_incomingmessage_source(this.__wbg_ptr, addHeapObject(arg0));
    }
    /**
     * @returns {string | undefined}
     */
    get topic() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_incomingmessage_topic(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string | null} [arg0]
     */
    set topic(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_incomingmessage_topic(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) IncomingMessage.prototype[Symbol.dispose] = IncomingMessage.prototype.free;

const IpcClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ipcclient_free(ptr >>> 0, 1));
/**
 * JavaScript wrapper around the IPC client. For more information, see the
 * [IpcClient] documentation.
 */
export class IpcClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(IpcClient.prototype);
        obj.__wbg_ptr = ptr;
        IpcClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IpcClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ipcclient_free(ptr, 0);
    }
    /**
     * @returns {Promise<boolean>}
     */
    isRunning() {
        const ret = wasm.ipcclient_isRunning(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * Create a new `IpcClient` instance with an in-memory session repository for saving
     * sessions within the SDK.
     * @param {IpcCommunicationBackend} communication_provider
     * @returns {IpcClient}
     */
    static newWithSdkInMemorySessions(communication_provider) {
        _assertClass(communication_provider, IpcCommunicationBackend);
        const ret = wasm.ipcclient_newWithSdkInMemorySessions(communication_provider.__wbg_ptr);
        return IpcClient.__wrap(ret);
    }
    /**
     * Create a new `IpcClient` instance with a client-managed session repository for saving
     * sessions using State Provider.
     * @param {IpcCommunicationBackend} communication_provider
     * @param {IpcSessionRepository} session_repository
     * @returns {IpcClient}
     */
    static newWithClientManagedSessions(communication_provider, session_repository) {
        _assertClass(communication_provider, IpcCommunicationBackend);
        const ret = wasm.ipcclient_newWithClientManagedSessions(communication_provider.__wbg_ptr, addHeapObject(session_repository));
        return IpcClient.__wrap(ret);
    }
    /**
     * @param {OutgoingMessage} message
     * @returns {Promise<void>}
     */
    send(message) {
        _assertClass(message, OutgoingMessage);
        var ptr0 = message.__destroy_into_raw();
        const ret = wasm.ipcclient_send(this.__wbg_ptr, ptr0);
        return takeObject(ret);
    }
    /**
     * @returns {Promise<void>}
     */
    start() {
        const ret = wasm.ipcclient_start(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @returns {Promise<IpcClientSubscription>}
     */
    subscribe() {
        const ret = wasm.ipcclient_subscribe(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) IpcClient.prototype[Symbol.dispose] = IpcClient.prototype.free;

const IpcClientSubscriptionFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ipcclientsubscription_free(ptr >>> 0, 1));
/**
 * JavaScript wrapper around the IPC client subscription. For more information, see the
 * [IpcClientSubscription](crate::IpcClientSubscription) documentation.
 */
export class IpcClientSubscription {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(IpcClientSubscription.prototype);
        obj.__wbg_ptr = ptr;
        IpcClientSubscriptionFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IpcClientSubscriptionFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ipcclientsubscription_free(ptr, 0);
    }
    /**
     * @param {AbortSignal | null} [abort_signal]
     * @returns {Promise<IncomingMessage>}
     */
    receive(abort_signal) {
        const ret = wasm.ipcclientsubscription_receive(this.__wbg_ptr, isLikeNone(abort_signal) ? 0 : addHeapObject(abort_signal));
        return takeObject(ret);
    }
}
if (Symbol.dispose) IpcClientSubscription.prototype[Symbol.dispose] = IpcClientSubscription.prototype.free;

const IpcCommunicationBackendFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_ipccommunicationbackend_free(ptr >>> 0, 1));
/**
 * JavaScript implementation of the `CommunicationBackend` trait for IPC communication.
 */
export class IpcCommunicationBackend {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        IpcCommunicationBackendFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_ipccommunicationbackend_free(ptr, 0);
    }
    /**
     * Creates a new instance of the JavaScript communication backend.
     * @param {IpcCommunicationBackendSender} sender
     */
    constructor(sender) {
        const ret = wasm.ipccommunicationbackend_new(addHeapObject(sender));
        this.__wbg_ptr = ret >>> 0;
        IpcCommunicationBackendFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Used by JavaScript to provide an incoming message to the IPC framework.
     * @param {IncomingMessage} message
     */
    receive(message) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            _assertClass(message, IncomingMessage);
            var ptr0 = message.__destroy_into_raw();
            wasm.ipccommunicationbackend_receive(retptr, this.__wbg_ptr, ptr0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) IpcCommunicationBackend.prototype[Symbol.dispose] = IpcCommunicationBackend.prototype.free;

const LoginClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_loginclient_free(ptr >>> 0, 1));
/**
 * Client for authenticating Bitwarden users.
 *
 * Handles unauthenticated operations to obtain access tokens from the Identity API.
 * After successful authentication, use the returned tokens to create an authenticated core client.
 *
 * # Lifecycle
 *
 * 1. Create `LoginClient` via `AuthClient`
 * 2. Call login method
 * 3. Use returned tokens with authenticated core client
 *
 * # Password Login Example
 *
 * ```rust,no_run
 * # use bitwarden_auth::{AuthClient, login::login_via_password::PasswordLoginRequest};
 * # use bitwarden_auth::login::models::{LoginRequest, LoginDeviceRequest, LoginResponse};
 * # use bitwarden_core::{Client, ClientSettings, DeviceType};
 * # async fn example(email: String, password: String) -> Result<(), Box<dyn std::error::Error>> {
 * // Create auth client
 * let client = Client::new(None);
 * let auth_client = AuthClient::new(client);
 *
 * // Configure client settings and create login client
 * let settings = ClientSettings {
 *     identity_url: "https://identity.bitwarden.com".to_string(),
 *     api_url: "https://api.bitwarden.com".to_string(),
 *     user_agent: "MyApp/1.0".to_string(),
 *     device_type: DeviceType::SDK,
 *     device_identifier: None,
 *     bitwarden_client_version: None,
 *     bitwarden_package_type: None,
 * };
 * let login_client = auth_client.login(settings);
 *
 * // Get user's KDF config
 * let prelogin = login_client.get_password_prelogin(email.clone()).await?;
 *
 * // Login with credentials
 * let response = login_client.login_via_password(PasswordLoginRequest {
 *     login_request: LoginRequest {
 *         client_id: "connector".to_string(),
 *         device: LoginDeviceRequest {
 *             device_type: DeviceType::SDK,
 *             device_identifier: "device-id".to_string(),
 *             device_name: "My Device".to_string(),
 *             device_push_token: None,
 *         },
 *     },
 *     email,
 *     password,
 *     prelogin_response: prelogin,
 * }).await?;
 *
 * // Use tokens from response for authenticated requests
 * match response {
 *     LoginResponse::Authenticated(success) => {
 *         let access_token = success.access_token;
 *         // Use access_token for authenticated requests
 *     }
 * }
 * # Ok(())
 * # }
 * ```
 */
export class LoginClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LoginClient.prototype);
        obj.__wbg_ptr = ptr;
        LoginClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LoginClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_loginclient_free(ptr, 0);
    }
    /**
     * Retrieves the data required before authenticating with a password.
     * This includes the user's KDF configuration needed to properly derive the master key.
     * @param {string} email
     * @returns {Promise<PasswordPreloginResponse>}
     */
    get_password_prelogin(email) {
        const ptr0 = passStringToWasm0(email, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.loginclient_get_password_prelogin(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Authenticates a user via email and master password.
     *
     * Derives the master password hash using KDF settings from prelogin, then sends
     * the authentication request to obtain access tokens and vault keys.
     * @param {PasswordLoginRequest} request
     * @returns {Promise<LoginResponse>}
     */
    login_via_password(request) {
        const ret = wasm.loginclient_login_via_password(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
}
if (Symbol.dispose) LoginClient.prototype[Symbol.dispose] = LoginClient.prototype.free;

const OutgoingMessageFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_outgoingmessage_free(ptr >>> 0, 1));

export class OutgoingMessage {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(OutgoingMessage.prototype);
        obj.__wbg_ptr = ptr;
        OutgoingMessageFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        OutgoingMessageFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_outgoingmessage_free(ptr, 0);
    }
    /**
     * Create a new message and encode the payload as JSON.
     * @param {any} payload
     * @param {Endpoint} destination
     * @param {string | null} [topic]
     * @returns {OutgoingMessage}
     */
    static new_json_payload(payload, destination, topic) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            var ptr0 = isLikeNone(topic) ? 0 : passStringToWasm0(topic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len0 = WASM_VECTOR_LEN;
            wasm.outgoingmessage_new_json_payload(retptr, addHeapObject(payload), addHeapObject(destination), ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return OutgoingMessage.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {Uint8Array} payload
     * @param {Endpoint} destination
     * @param {string | null} [topic]
     */
    constructor(payload, destination, topic) {
        const ptr0 = passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(topic) ? 0 : passStringToWasm0(topic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.outgoingmessage_new(ptr0, len0, addHeapObject(destination), ptr1, len1);
        this.__wbg_ptr = ret >>> 0;
        OutgoingMessageFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * @returns {Uint8Array}
     */
    get payload() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_outgoingmessage_payload(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {Uint8Array} arg0
     */
    set payload(arg0) {
        const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_outgoingmessage_payload(this.__wbg_ptr, ptr0, len0);
    }
    /**
     * @returns {Endpoint}
     */
    get destination() {
        const ret = wasm.__wbg_get_incomingmessage_destination(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * @param {Endpoint} arg0
     */
    set destination(arg0) {
        wasm.__wbg_set_incomingmessage_destination(this.__wbg_ptr, addHeapObject(arg0));
    }
    /**
     * @returns {string | undefined}
     */
    get topic() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_outgoingmessage_topic(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string | null} [arg0]
     */
    set topic(arg0) {
        var ptr0 = isLikeNone(arg0) ? 0 : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        wasm.__wbg_set_outgoingmessage_topic(this.__wbg_ptr, ptr0, len0);
    }
}
if (Symbol.dispose) OutgoingMessage.prototype[Symbol.dispose] = OutgoingMessage.prototype.free;

const PasswordManagerClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_passwordmanagerclient_free(ptr >>> 0, 1));
/**
 * The main entry point for the Bitwarden SDK in WebAssembly environments
 */
export class PasswordManagerClient {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PasswordManagerClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_passwordmanagerclient_free(ptr, 0);
    }
    /**
     * Bitwarden licensed operations.
     * @returns {CommercialPasswordManagerClient}
     */
    commercial() {
        const ret = wasm.passwordmanagerclient_commercial(this.__wbg_ptr);
        return CommercialPasswordManagerClient.__wrap(ret);
    }
    /**
     * User crypto management related operations.
     * @returns {UserCryptoManagementClient}
     */
    user_crypto_management() {
        const ret = wasm.passwordmanagerclient_user_crypto_management(this.__wbg_ptr);
        return UserCryptoManagementClient.__wrap(ret);
    }
    /**
     * Initialize a new instance of the SDK client
     * @param {any} token_provider
     * @param {ClientSettings | null} [settings]
     */
    constructor(token_provider, settings) {
        const ret = wasm.passwordmanagerclient_new(addHeapObject(token_provider), isLikeNone(settings) ? 0 : addHeapObject(settings));
        this.__wbg_ptr = ret >>> 0;
        PasswordManagerClientFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Auth related operations.
     * @returns {AuthClient}
     */
    auth() {
        const ret = wasm.passwordmanagerclient_auth(this.__wbg_ptr);
        return AuthClient.__wrap(ret);
    }
    /**
     * Test method, echoes back the input
     * @param {string} msg
     * @returns {string}
     */
    echo(msg) {
        let deferred2_0;
        let deferred2_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(msg, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.passwordmanagerclient_echo(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred2_0 = r0;
            deferred2_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
        }
    }
    /**
     * Test method, always throws an error
     * @param {string} msg
     */
    throw(msg) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(msg, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.passwordmanagerclient_throw(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Vault item related operations.
     * @returns {VaultClient}
     */
    vault() {
        const ret = wasm.passwordmanagerclient_vault(this.__wbg_ptr);
        return VaultClient.__wrap(ret);
    }
    /**
     * Crypto related operations.
     * @returns {CryptoClient}
     */
    crypto() {
        const ret = wasm.passwordmanagerclient_crypto(this.__wbg_ptr);
        return CryptoClient.__wrap(ret);
    }
    /**
     * Returns the current SDK version
     * @returns {string}
     */
    version() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.passwordmanagerclient_version(retptr, this.__wbg_ptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
     * Test method, calls http endpoint
     * @param {string} url
     * @returns {Promise<string>}
     */
    http_get(url) {
        const ptr0 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.passwordmanagerclient_http_get(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Constructs a specific client for platform-specific functionality
     * @returns {PlatformClient}
     */
    platform() {
        const ret = wasm.passwordmanagerclient_platform(this.__wbg_ptr);
        return PlatformClient.__wrap(ret);
    }
    /**
     * Exporter related operations.
     * @returns {ExporterClient}
     */
    exporters() {
        const ret = wasm.passwordmanagerclient_exporters(this.__wbg_ptr);
        return ExporterClient.__wrap(ret);
    }
    /**
     * Constructs a specific client for generating passwords and passphrases
     * @returns {GeneratorClient}
     */
    generator() {
        const ret = wasm.passwordmanagerclient_generator(this.__wbg_ptr);
        return GeneratorClient.__wrap(ret);
    }
}
if (Symbol.dispose) PasswordManagerClient.prototype[Symbol.dispose] = PasswordManagerClient.prototype.free;

const PlatformClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_platformclient_free(ptr >>> 0, 1));

export class PlatformClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PlatformClient.prototype);
        obj.__wbg_ptr = ptr;
        PlatformClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlatformClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_platformclient_free(ptr, 0);
    }
    /**
     * Load feature flags into the client
     * @param {FeatureFlags} flags
     */
    load_flags(flags) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.platformclient_load_flags(retptr, this.__wbg_ptr, addHeapObject(flags));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {StateClient}
     */
    state() {
        const ret = wasm.passwordmanagerclient_platform(this.__wbg_ptr);
        return StateClient.__wrap(ret);
    }
}
if (Symbol.dispose) PlatformClient.prototype[Symbol.dispose] = PlatformClient.prototype.free;

const PureCryptoFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_purecrypto_free(ptr >>> 0, 1));
/**
 * This module represents a stopgap solution to provide access to primitive crypto functions for JS
 * clients. It is not intended to be used outside of the JS clients and this pattern should not be
 * proliferated. It is necessary because we want to use SDK crypto prior to the SDK being fully
 * responsible for state and keys.
 */
export class PureCrypto {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PureCryptoFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_purecrypto_free(ptr, 0);
    }
    /**
     * Generates a cryptographically secure random number between the given min and max
     * (inclusive).
     * @param {number} min
     * @param {number} max
     * @returns {number}
     */
    static random_number(min, max) {
        const ret = wasm.purecrypto_random_number(min, max);
        return ret >>> 0;
    }
    /**
     * Decrypts data using RSAES-OAEP with SHA-1
     * HAZMAT WARNING: Do not use outside of implementing cryptofunctionservice
     * @param {Uint8Array} encrypted_data
     * @param {Uint8Array} private_key
     * @returns {Uint8Array}
     */
    static rsa_decrypt_data(encrypted_data, private_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(encrypted_data, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(private_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_rsa_decrypt_data(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Encrypts data using RSAES-OAEP with SHA-1
     * HAZMAT WARNING: Do not use outside of implementing cryptofunctionservice
     * @param {Uint8Array} plain_data
     * @param {Uint8Array} public_key
     * @returns {Uint8Array}
     */
    static rsa_encrypt_data(plain_data, public_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(plain_data, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(public_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_rsa_encrypt_data(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * DEPRECATED: Use `symmetric_decrypt_string` instead.
     * Cleanup ticket: <https://bitwarden.atlassian.net/browse/PM-21247>
     * @param {string} enc_string
     * @param {Uint8Array} key
     * @returns {string}
     */
    static symmetric_decrypt(enc_string, key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(enc_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_decrypt(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * Wraps (encrypts) a symmetric key using a symmetric wrapping key, returning the wrapped key
     * as an EncString.
     * @param {Uint8Array} key_to_be_wrapped
     * @param {Uint8Array} wrapping_key
     * @returns {string}
     */
    static wrap_symmetric_key(key_to_be_wrapped, wrapping_key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(key_to_be_wrapped, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(wrapping_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_wrap_symmetric_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * Derive output of the KDF for a [bitwarden_crypto::Kdf] configuration.
     * @param {Uint8Array} password
     * @param {Uint8Array} salt
     * @param {Kdf} kdf
     * @returns {Uint8Array}
     */
    static derive_kdf_material(password, salt, kdf) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(password, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(salt, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_derive_kdf_material(retptr, ptr0, len0, ptr1, len1, addHeapObject(kdf));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Generates a new RSA key pair and returns the private key
     * HAZMAT WARNING: Do not use outside of implementing cryptofunctionservice
     * @returns {Uint8Array}
     */
    static rsa_generate_keypair() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.purecrypto_rsa_generate_keypair(retptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Unwraps (decrypts) a wrapped symmetric key using a symmetric wrapping key, returning the
     * unwrapped key as a serialized byte array.
     * @param {string} wrapped_key
     * @param {Uint8Array} wrapping_key
     * @returns {Uint8Array}
     */
    static unwrap_symmetric_key(wrapped_key, wrapping_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(wrapped_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(wrapping_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_unwrap_symmetric_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Given a decrypted private RSA key PKCS8 DER this
     * returns the corresponding public RSA key in DER format.
     * HAZMAT WARNING: Do not use outside of implementing cryptofunctionservice
     * @param {Uint8Array} private_key
     * @returns {Uint8Array}
     */
    static rsa_extract_public_key(private_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(private_key, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.purecrypto_rsa_extract_public_key(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v2 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v2;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Wraps (encrypts) a PKCS8 DER encoded decapsulation (private) key using a symmetric wrapping
     * key,
     * @param {Uint8Array} decapsulation_key
     * @param {Uint8Array} wrapping_key
     * @returns {string}
     */
    static wrap_decapsulation_key(decapsulation_key, wrapping_key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(decapsulation_key, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(wrapping_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_wrap_decapsulation_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * Wraps (encrypts) an SPKI DER encoded encapsulation (public) key using a symmetric wrapping
     * key. Note: Usually, a public key is - by definition - public, so this should not be
     * used. The specific use-case for this function is to enable rotateable key sets, where
     * the "public key" is not public, with the intent of preventing the server from being able
     * to overwrite the user key unlocked by the rotateable keyset.
     * @param {Uint8Array} encapsulation_key
     * @param {Uint8Array} wrapping_key
     * @returns {string}
     */
    static wrap_encapsulation_key(encapsulation_key, wrapping_key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(encapsulation_key, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(wrapping_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_wrap_encapsulation_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {string} enc_string
     * @param {Uint8Array} key
     * @returns {Uint8Array}
     */
    static symmetric_decrypt_bytes(enc_string, key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(enc_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_decrypt_bytes(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * DEPRECATED: Only used by send keys
     * @param {Uint8Array} plain
     * @param {Uint8Array} key
     * @returns {string}
     */
    static symmetric_encrypt_bytes(plain, key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(plain, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_encrypt_bytes(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * Decapsulates (decrypts) a symmetric key using an decapsulation-key/private-key in PKCS8
     * DER format. Note: This is unsigned, so the sender's authenticity cannot be verified by the
     * recipient.
     * @param {string} encapsulated_key
     * @param {Uint8Array} decapsulation_key
     * @returns {Uint8Array}
     */
    static decapsulate_key_unsigned(encapsulated_key, decapsulation_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(encapsulated_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(decapsulation_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_decapsulate_key_unsigned(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Encapsulates (encrypts) a symmetric key using an public-key/encapsulation-key
     * in SPKI format, returning the encapsulated key as a string. Note: This is unsigned, so
     * the sender's authenticity cannot be verified by the recipient.
     * @param {Uint8Array} shared_key
     * @param {Uint8Array} encapsulation_key
     * @returns {string}
     */
    static encapsulate_key_unsigned(shared_key, encapsulation_key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(shared_key, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(encapsulation_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_encapsulate_key_unsigned(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {string} enc_string
     * @param {Uint8Array} key
     * @returns {string}
     */
    static symmetric_decrypt_string(enc_string, key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(enc_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_decrypt_string(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * @param {string} plain
     * @param {Uint8Array} key
     * @returns {string}
     */
    static symmetric_encrypt_string(plain, key) {
        let deferred4_0;
        let deferred4_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(plain, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_encrypt_string(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr3 = r0;
            var len3 = r1;
            if (r3) {
                ptr3 = 0; len3 = 0;
                throw takeObject(r2);
            }
            deferred4_0 = ptr3;
            deferred4_1 = len3;
            return getStringFromWasm0(ptr3, len3);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
        }
    }
    /**
     * Unwraps (decrypts) a wrapped PKCS8 DER encoded decapsulation (private) key using a symmetric
     * wrapping key.
     * @param {string} wrapped_key
     * @param {Uint8Array} wrapping_key
     * @returns {Uint8Array}
     */
    static unwrap_decapsulation_key(wrapped_key, wrapping_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(wrapped_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(wrapping_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_unwrap_decapsulation_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Unwraps (decrypts) a wrapped SPKI DER encoded encapsulation (public) key using a symmetric
     * wrapping key.
     * @param {string} wrapped_key
     * @param {Uint8Array} wrapping_key
     * @returns {Uint8Array}
     */
    static unwrap_encapsulation_key(wrapped_key, wrapping_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(wrapped_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(wrapping_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_unwrap_encapsulation_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {Uint8Array} enc_bytes
     * @param {Uint8Array} key
     * @returns {Uint8Array}
     */
    static symmetric_decrypt_filedata(enc_bytes, key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(enc_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_decrypt_filedata(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {Uint8Array} plain
     * @param {Uint8Array} key
     * @returns {Uint8Array}
     */
    static symmetric_encrypt_filedata(plain, key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(plain, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_encrypt_filedata(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {Uint8Array}
     */
    static make_user_key_aes256_cbc_hmac() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.purecrypto_make_user_key_aes256_cbc_hmac(retptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Given a wrapped signing key and the symmetric key it is wrapped with, this returns
     * the corresponding verifying key.
     * @param {string} signing_key
     * @param {Uint8Array} wrapping_key
     * @returns {Uint8Array}
     */
    static verifying_key_for_signing_key(signing_key, wrapping_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(signing_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(wrapping_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_verifying_key_for_signing_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * DEPRECATED: Use `symmetric_decrypt_filedata` instead.
     * Cleanup ticket: <https://bitwarden.atlassian.net/browse/PM-21247>
     * @param {Uint8Array} enc_bytes
     * @param {Uint8Array} key
     * @returns {Uint8Array}
     */
    static symmetric_decrypt_array_buffer(enc_bytes, key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(enc_bytes, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_symmetric_decrypt_array_buffer(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * Returns the algorithm used for the given verifying key.
     * @param {Uint8Array} verifying_key
     * @returns {SignatureAlgorithm}
     */
    static key_algorithm_for_verifying_key(verifying_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(verifying_key, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.purecrypto_key_algorithm_for_verifying_key(retptr, ptr0, len0);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} encrypted_user_key
     * @param {Uint8Array} master_key
     * @returns {Uint8Array}
     */
    static decrypt_user_key_with_master_key(encrypted_user_key, master_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(encrypted_user_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(master_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_decrypt_user_key_with_master_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @returns {Uint8Array}
     */
    static make_user_key_xchacha20_poly1305() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.purecrypto_make_user_key_xchacha20_poly1305(retptr);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var v1 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * For a given signing identity (verifying key), this function verifies that the signing
     * identity claimed ownership of the public key. This is a one-sided claim and merely shows
     * that the signing identity has the intent to receive messages encrypted to the public
     * key.
     * @param {Uint8Array} signed_public_key
     * @param {Uint8Array} verifying_key
     * @returns {Uint8Array}
     */
    static verify_and_unwrap_signed_public_key(signed_public_key, verifying_key) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(signed_public_key, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArray8ToWasm0(verifying_key, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.purecrypto_verify_and_unwrap_signed_public_key(retptr, ptr0, len0, ptr1, len1);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v3 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v3;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {string} encrypted_user_key
     * @param {string} master_password
     * @param {string} email
     * @param {Kdf} kdf
     * @returns {Uint8Array}
     */
    static decrypt_user_key_with_master_password(encrypted_user_key, master_password, email, kdf) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(encrypted_user_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(master_password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(email, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len2 = WASM_VECTOR_LEN;
            wasm.purecrypto_decrypt_user_key_with_master_password(retptr, ptr0, len0, ptr1, len1, ptr2, len2, addHeapObject(kdf));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            if (r3) {
                throw takeObject(r2);
            }
            var v4 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1, 1);
            return v4;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
     * @param {Uint8Array} user_key
     * @param {string} master_password
     * @param {string} email
     * @param {Kdf} kdf
     * @returns {string}
     */
    static encrypt_user_key_with_master_password(user_key, master_password, email, kdf) {
        let deferred5_0;
        let deferred5_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passArray8ToWasm0(user_key, wasm.__wbindgen_malloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(master_password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            const ptr2 = passStringToWasm0(email, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len2 = WASM_VECTOR_LEN;
            wasm.purecrypto_encrypt_user_key_with_master_password(retptr, ptr0, len0, ptr1, len1, ptr2, len2, addHeapObject(kdf));
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
            var ptr4 = r0;
            var len4 = r1;
            if (r3) {
                ptr4 = 0; len4 = 0;
                throw takeObject(r2);
            }
            deferred5_0 = ptr4;
            deferred5_1 = len4;
            return getStringFromWasm0(ptr4, len4);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred5_0, deferred5_1, 1);
        }
    }
}
if (Symbol.dispose) PureCrypto.prototype[Symbol.dispose] = PureCrypto.prototype.free;

const RegistrationClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_registrationclient_free(ptr >>> 0, 1));
/**
 * Client for initializing a user account.
 */
export class RegistrationClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(RegistrationClient.prototype);
        obj.__wbg_ptr = ptr;
        RegistrationClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        RegistrationClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_registrationclient_free(ptr, 0);
    }
    /**
     * Initializes a new cryptographic state for a user and posts it to the server; enrolls in
     * admin password reset and finally enrolls the user to TDE unlock.
     * @param {TdeRegistrationRequest} request
     * @returns {Promise<TdeRegistrationResponse>}
     */
    post_keys_for_tde_registration(request) {
        const ret = wasm.registrationclient_post_keys_for_tde_registration(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Initializes a new cryptographic state for a user and posts it to the server;
     * enrolls the user to master password unlock.
     * @param {JitMasterPasswordRegistrationRequest} request
     * @returns {Promise<JitMasterPasswordRegistrationResponse>}
     */
    post_keys_for_jit_password_registration(request) {
        const ret = wasm.registrationclient_post_keys_for_jit_password_registration(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Initializes a new cryptographic state for a user and posts it to the server; enrolls the
     * user to key connector unlock.
     * @param {string} key_connector_url
     * @param {string} sso_org_identifier
     * @param {UserId} user_id
     * @returns {Promise<KeyConnectorRegistrationResult>}
     */
    post_keys_for_key_connector_registration(key_connector_url, sso_org_identifier, user_id) {
        const ptr0 = passStringToWasm0(key_connector_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(sso_org_identifier, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.registrationclient_post_keys_for_key_connector_registration(this.__wbg_ptr, ptr0, len0, ptr1, len1, addHeapObject(user_id));
        return takeObject(ret);
    }
}
if (Symbol.dispose) RegistrationClient.prototype[Symbol.dispose] = RegistrationClient.prototype.free;

const SendAccessClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_sendaccessclient_free(ptr >>> 0, 1));
/**
 * The `SendAccessClient` is used to interact with the Bitwarden API to get send access tokens.
 */
export class SendAccessClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(SendAccessClient.prototype);
        obj.__wbg_ptr = ptr;
        SendAccessClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        SendAccessClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_sendaccessclient_free(ptr, 0);
    }
    /**
     * Requests a new send access token.
     * @param {SendAccessTokenRequest} request
     * @returns {Promise<SendAccessTokenResponse>}
     */
    request_send_access_token(request) {
        const ret = wasm.sendaccessclient_request_send_access_token(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
}
if (Symbol.dispose) SendAccessClient.prototype[Symbol.dispose] = SendAccessClient.prototype.free;

const ServerCommunicationConfigClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_servercommunicationconfigclient_free(ptr >>> 0, 1));
/**
 * JavaScript wrapper for ServerCommunicationConfigClient
 *
 * This provides TypeScript access to the server communication configuration client,
 * allowing clients to check bootstrap requirements and retrieve cookies for HTTP requests.
 */
export class ServerCommunicationConfigClient {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ServerCommunicationConfigClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_servercommunicationconfigclient_free(ptr, 0);
    }
    /**
     * Retrieves the server communication configuration for a hostname
     *
     * If no configuration exists, returns a default Direct bootstrap configuration.
     *
     * # Arguments
     *
     * * `hostname` - The server hostname (e.g., "vault.acme.com")
     *
     * # Errors
     *
     * Returns an error if the repository fails to retrieve the configuration.
     * @param {string} hostname
     * @returns {Promise<ServerCommunicationConfig>}
     */
    getConfig(hostname) {
        const ptr0 = passStringToWasm0(hostname, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.servercommunicationconfigclient_getConfig(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Acquires a cookie from the platform and saves it to the repository
     *
     * This method calls the platform API to trigger cookie acquisition (e.g., browser
     * redirect to IdP), then validates and stores the acquired cookie in the repository.
     *
     * # Arguments
     *
     * * `hostname` - The server hostname (e.g., "vault.acme.com")
     *
     * # Errors
     *
     * Returns an error if:
     * - Cookie acquisition was cancelled by the user
     * - Server configuration doesn't support SSO cookies (Direct bootstrap)
     * - Acquired cookie name doesn't match expected name
     * - Repository operations fail
     * @param {string} hostname
     * @returns {Promise<void>}
     */
    acquireCookie(hostname) {
        const ptr0 = passStringToWasm0(hostname, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.servercommunicationconfigclient_acquireCookie(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Determines if cookie bootstrapping is needed for this hostname
     *
     * # Arguments
     *
     * * `hostname` - The server hostname (e.g., "vault.acme.com")
     * @param {string} hostname
     * @returns {Promise<boolean>}
     */
    needsBootstrap(hostname) {
        const ptr0 = passStringToWasm0(hostname, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.servercommunicationconfigclient_needsBootstrap(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
     * Sets the server communication configuration for a hostname
     *
     * This method saves the provided communication configuration to the repository.
     * Typically called when receiving the `/api/config` response from the server.
     *
     * # Arguments
     *
     * * `hostname` - The server hostname (e.g., "vault.acme.com")
     * * `config` - The server communication configuration to store
     *
     * # Errors
     *
     * Returns an error if the repository save operation fails
     * @param {string} hostname
     * @param {ServerCommunicationConfig} config
     * @returns {Promise<void>}
     */
    setCommunicationType(hostname, config) {
        const ptr0 = passStringToWasm0(hostname, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.servercommunicationconfigclient_setCommunicationType(this.__wbg_ptr, ptr0, len0, addHeapObject(config));
        return takeObject(ret);
    }
    /**
     * Creates a new ServerCommunicationConfigClient with a JavaScript repository and platform API
     *
     * The repository should be backed by StateProvider (or equivalent
     * storage mechanism) for persistence.
     *
     * # Arguments
     *
     * * `repository` - JavaScript implementation of the repository interface
     * * `platform_api` - JavaScript implementation of the platform API interface
     * @param {ServerCommunicationConfigRepository} repository
     * @param {ServerCommunicationConfigPlatformApi} platform_api
     */
    constructor(repository, platform_api) {
        const ret = wasm.servercommunicationconfigclient_new(addHeapObject(repository), addHeapObject(platform_api));
        this.__wbg_ptr = ret >>> 0;
        ServerCommunicationConfigClientFinalization.register(this, this.__wbg_ptr, this);
        return this;
    }
    /**
     * Returns all cookies that should be included in requests to this server
     *
     * Returns an array of [cookie_name, cookie_value] pairs.
     *
     * # Arguments
     *
     * * `hostname` - The server hostname (e.g., "vault.acme.com")
     * @param {string} hostname
     * @returns {Promise<any>}
     */
    cookies(hostname) {
        const ptr0 = passStringToWasm0(hostname, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.servercommunicationconfigclient_cookies(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
}
if (Symbol.dispose) ServerCommunicationConfigClient.prototype[Symbol.dispose] = ServerCommunicationConfigClient.prototype.free;

const StateClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_stateclient_free(ptr >>> 0, 1));

export class StateClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(StateClient.prototype);
        obj.__wbg_ptr = ptr;
        StateClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        StateClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_stateclient_free(ptr, 0);
    }
    /**
     * Initialize the database for SDK managed repositories.
     * @param {IndexedDbConfiguration} configuration
     * @returns {Promise<void>}
     */
    initialize_state(configuration) {
        const ret = wasm.stateclient_initialize_state(this.__wbg_ptr, addHeapObject(configuration));
        return takeObject(ret);
    }
    /**
     * @param {any} cipher_repository
     */
    register_cipher_repository(cipher_repository) {
        wasm.stateclient_register_cipher_repository(this.__wbg_ptr, addHeapObject(cipher_repository));
    }
    /**
     * @param {any} store
     */
    register_folder_repository(store) {
        wasm.stateclient_register_folder_repository(this.__wbg_ptr, addHeapObject(store));
    }
    /**
     * @param {Repositories} repositories
     */
    register_client_managed_repositories(repositories) {
        wasm.stateclient_register_client_managed_repositories(this.__wbg_ptr, addHeapObject(repositories));
    }
}
if (Symbol.dispose) StateClient.prototype[Symbol.dispose] = StateClient.prototype.free;

const TotpClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_totpclient_free(ptr >>> 0, 1));

export class TotpClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TotpClient.prototype);
        obj.__wbg_ptr = ptr;
        TotpClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TotpClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_totpclient_free(ptr, 0);
    }
    /**
     * Generates a TOTP code from a provided key
     *
     * # Arguments
     * - `key` - Can be:
     *     - A base32 encoded string
     *     - OTP Auth URI
     *     - Steam URI
     * - `time_ms` - Optional timestamp in milliseconds
     * @param {string} key
     * @param {number | null} [time_ms]
     * @returns {TotpResponse}
     */
    generate_totp(key, time_ms) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.totpclient_generate_totp(retptr, this.__wbg_ptr, ptr0, len0, !isLikeNone(time_ms), isLikeNone(time_ms) ? 0 : time_ms);
            var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
            var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
            var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
if (Symbol.dispose) TotpClient.prototype[Symbol.dispose] = TotpClient.prototype.free;

const UserCryptoManagementClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_usercryptomanagementclient_free(ptr >>> 0, 1));
/**
 * Client for managing the cryptographic machinery of a user account, including key-rotation.
 */
export class UserCryptoManagementClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(UserCryptoManagementClient.prototype);
        obj.__wbg_ptr = ptr;
        UserCryptoManagementClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        UserCryptoManagementClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_usercryptomanagementclient_free(ptr, 0);
    }
    /**
     * Rotates the user's encryption keys. The user must have a master-password.
     * @param {RotateUserKeysRequest} request
     * @returns {Promise<void>}
     */
    rotate_user_keys(request) {
        const ret = wasm.usercryptomanagementclient_rotate_user_keys(this.__wbg_ptr, addHeapObject(request));
        return takeObject(ret);
    }
    /**
     * Fetches the organization public keys for V1 organization memberships for the user.
     * These have to be trusted manually be the user before rotating.
     * @returns {Promise<V1OrganizationMembership[]>}
     */
    get_untrusted_organization_public_keys() {
        const ret = wasm.usercryptomanagementclient_get_untrusted_organization_public_keys(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
     * Fetches the emergency access public keys for V1 emergency access memberships for the user.
     * These have to be trusted manually be the user before rotating.
     * @returns {Promise<V1EmergencyAccessMembership[]>}
     */
    get_untrusted_emergency_access_public_keys() {
        const ret = wasm.usercryptomanagementclient_get_untrusted_emergency_access_public_keys(this.__wbg_ptr);
        return takeObject(ret);
    }
}
if (Symbol.dispose) UserCryptoManagementClient.prototype[Symbol.dispose] = UserCryptoManagementClient.prototype.free;

const VaultClientFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_vaultclient_free(ptr >>> 0, 1));

export class VaultClient {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(VaultClient.prototype);
        obj.__wbg_ptr = ptr;
        VaultClientFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        VaultClientFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_vaultclient_free(ptr, 0);
    }
    /**
     * Attachment related operations.
     * @returns {AttachmentsClient}
     */
    attachments() {
        const ret = wasm.ciphersclient_admin(this.__wbg_ptr);
        return AttachmentsClient.__wrap(ret);
    }
    /**
     * Cipher risk evaluation operations.
     * @returns {CipherRiskClient}
     */
    cipher_risk() {
        const ret = wasm.ciphersclient_admin(this.__wbg_ptr);
        return CipherRiskClient.__wrap(ret);
    }
    /**
     * Collection related operations.
     * @returns {CollectionsClient}
     */
    collections() {
        const ret = wasm.ciphersclient_admin(this.__wbg_ptr);
        return CollectionsClient.__wrap(ret);
    }
    /**
     * TOTP related operations.
     * @returns {TotpClient}
     */
    totp() {
        const ret = wasm.ciphersclient_admin(this.__wbg_ptr);
        return TotpClient.__wrap(ret);
    }
    /**
     * Cipher related operations.
     * @returns {CiphersClient}
     */
    ciphers() {
        const ret = wasm.ciphersclient_admin(this.__wbg_ptr);
        return CiphersClient.__wrap(ret);
    }
    /**
     * Folder related operations.
     * @returns {FoldersClient}
     */
    folders() {
        const ret = wasm.ciphersclient_admin(this.__wbg_ptr);
        return FoldersClient.__wrap(ret);
    }
}
if (Symbol.dispose) VaultClient.prototype[Symbol.dispose] = VaultClient.prototype.free;

export function __wbg_Error_e83987f665cf5504(arg0, arg1) {
    const ret = Error(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

export function __wbg_Number_bb48ca12f395cd08(arg0) {
    const ret = Number(getObject(arg0));
    return ret;
};

export function __wbg_String_8f0eb39a4a4c2f66(arg0, arg1) {
    const ret = String(getObject(arg1));
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg___wbindgen_bigint_get_as_i64_f3ebc5a755000afd(arg0, arg1) {
    const v = getObject(arg1);
    const ret = typeof(v) === 'bigint' ? v : undefined;
    getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
};

export function __wbg___wbindgen_boolean_get_6d5a1ee65bab5f68(arg0) {
    const v = getObject(arg0);
    const ret = typeof(v) === 'boolean' ? v : undefined;
    return isLikeNone(ret) ? 0xFFFFFF : ret ? 1 : 0;
};

export function __wbg___wbindgen_debug_string_df47ffb5e35e6763(arg0, arg1) {
    const ret = debugString(getObject(arg1));
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg___wbindgen_in_bb933bd9e1b3bc0f(arg0, arg1) {
    const ret = getObject(arg0) in getObject(arg1);
    return ret;
};

export function __wbg___wbindgen_is_bigint_cb320707dcd35f0b(arg0) {
    const ret = typeof(getObject(arg0)) === 'bigint';
    return ret;
};

export function __wbg___wbindgen_is_function_ee8a6c5833c90377(arg0) {
    const ret = typeof(getObject(arg0)) === 'function';
    return ret;
};

export function __wbg___wbindgen_is_null_5e69f72e906cc57c(arg0) {
    const ret = getObject(arg0) === null;
    return ret;
};

export function __wbg___wbindgen_is_object_c818261d21f283a4(arg0) {
    const val = getObject(arg0);
    const ret = typeof(val) === 'object' && val !== null;
    return ret;
};

export function __wbg___wbindgen_is_string_fbb76cb2940daafd(arg0) {
    const ret = typeof(getObject(arg0)) === 'string';
    return ret;
};

export function __wbg___wbindgen_is_undefined_2d472862bd29a478(arg0) {
    const ret = getObject(arg0) === undefined;
    return ret;
};

export function __wbg___wbindgen_jsval_eq_6b13ab83478b1c50(arg0, arg1) {
    const ret = getObject(arg0) === getObject(arg1);
    return ret;
};

export function __wbg___wbindgen_jsval_loose_eq_b664b38a2f582147(arg0, arg1) {
    const ret = getObject(arg0) == getObject(arg1);
    return ret;
};

export function __wbg___wbindgen_number_get_a20bf9b85341449d(arg0, arg1) {
    const obj = getObject(arg1);
    const ret = typeof(obj) === 'number' ? obj : undefined;
    getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
};

export function __wbg___wbindgen_string_get_e4f06c90489ad01b(arg0, arg1) {
    const obj = getObject(arg1);
    const ret = typeof(obj) === 'string' ? obj : undefined;
    var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg___wbindgen_throw_b855445ff6a94295(arg0, arg1) {
    throw new Error(getStringFromWasm0(arg0, arg1));
};

export function __wbg__wbg_cb_unref_2454a539ea5790d9(arg0) {
    getObject(arg0)._wbg_cb_unref();
};

export function __wbg_abort_28ad55c5825b004d(arg0, arg1) {
    getObject(arg0).abort(getObject(arg1));
};

export function __wbg_abort_3b256cd5ad0ac232() { return handleError(function (arg0) {
    getObject(arg0).abort();
}, arguments) };

export function __wbg_abort_e7eb059f72f9ed0c(arg0) {
    getObject(arg0).abort();
};

export function __wbg_acquireCookies_e619046b176fe50d() { return handleError(function (arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).acquireCookies(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_addEventListener_2a32c0afd1525001(arg0, arg1, arg2, arg3) {
    getObject(arg0).addEventListener(getStringFromWasm0(arg1, arg2), getObject(arg3));
};

export function __wbg_append_45ddba58b0706f62() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    getObject(arg0).append(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
}, arguments) };

export function __wbg_append_892c5e2d5bdd60ac() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5) {
    getObject(arg0).append(getStringFromWasm0(arg1, arg2), getObject(arg3), getStringFromWasm0(arg4, arg5));
}, arguments) };

export function __wbg_append_b577eb3a177bc0fa() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    getObject(arg0).append(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
}, arguments) };

export function __wbg_append_cb0bba4cf263a60b() { return handleError(function (arg0, arg1, arg2, arg3) {
    getObject(arg0).append(getStringFromWasm0(arg1, arg2), getObject(arg3));
}, arguments) };

export function __wbg_arrayBuffer_b375eccb84b4ddf3() { return handleError(function (arg0) {
    const ret = getObject(arg0).arrayBuffer();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_call_525440f72fbfc0ea() { return handleError(function (arg0, arg1, arg2) {
    const ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_call_e762c39fa8ea36bf() { return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).call(getObject(arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_cipher_f16a08a147d99ddf(arg0) {
    const ret = getObject(arg0).cipher;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_clearTimeout_42d9ccd50822fd3a(arg0) {
    const ret = clearTimeout(takeObject(arg0));
    return addHeapObject(ret);
};

export function __wbg_collectionviewnodeitem_new(arg0) {
    const ret = CollectionViewNodeItem.__wrap(arg0);
    return addHeapObject(ret);
};

export function __wbg_createObjectStore_283a43a822bf49ca() { return handleError(function (arg0, arg1, arg2, arg3) {
    const ret = getObject(arg0).createObjectStore(getStringFromWasm0(arg1, arg2), getObject(arg3));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_crypto_86f2631e91b51511(arg0) {
    const ret = getObject(arg0).crypto;
    return addHeapObject(ret);
};

export function __wbg_debug_e55e1461940eb14d(arg0, arg1, arg2, arg3) {
    console.debug(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
};

export function __wbg_debug_f4b0c59db649db48(arg0) {
    console.debug(getObject(arg0));
};

export function __wbg_deleteObjectStore_444a266b213fafcf() { return handleError(function (arg0, arg1, arg2) {
    getObject(arg0).deleteObjectStore(getStringFromWasm0(arg1, arg2));
}, arguments) };

export function __wbg_delete_f808c4661e8e34c0() { return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).delete(getObject(arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_done_2042aa2670fb1db1(arg0) {
    const ret = getObject(arg0).done;
    return ret;
};

export function __wbg_entries_e171b586f8f6bdbf(arg0) {
    const ret = Object.entries(getObject(arg0));
    return addHeapObject(ret);
};

export function __wbg_error_3e929987fcd3e155() { return handleError(function (arg0) {
    const ret = getObject(arg0).error;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
}, arguments) };

export function __wbg_error_7534b8e9a36f1ab4(arg0, arg1) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg0;
        deferred0_1 = arg1;
        console.error(getStringFromWasm0(arg0, arg1));
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
};

export function __wbg_error_a7f8fbb0523dae15(arg0) {
    console.error(getObject(arg0));
};

export function __wbg_error_d8b22cf4e59a6791(arg0, arg1, arg2, arg3) {
    console.error(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
};

export function __wbg_fetch_6bbc32f991730587(arg0) {
    const ret = fetch(getObject(arg0));
    return addHeapObject(ret);
};

export function __wbg_fetch_f8ba0e29a9d6de0d(arg0, arg1) {
    const ret = getObject(arg0).fetch(getObject(arg1));
    return addHeapObject(ret);
};

export function __wbg_folder_2a7a10f1b7333e77(arg0) {
    const ret = getObject(arg0).folder;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_getAll_9121ade297db31db() { return handleError(function (arg0) {
    const ret = getObject(arg0).getAll();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_getFullYear_8240d5a15191feae(arg0) {
    const ret = getObject(arg0).getFullYear();
    return ret;
};

export function __wbg_getRandomValues_2a91986308c74a93() { return handleError(function (arg0, arg1) {
    globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
}, arguments) };

export function __wbg_getRandomValues_9c5c1b115e142bb8() { return handleError(function (arg0, arg1) {
    globalThis.crypto.getRandomValues(getArrayU8FromWasm0(arg0, arg1));
}, arguments) };

export function __wbg_getRandomValues_b3f15fcbfabb0f8b() { return handleError(function (arg0, arg1) {
    getObject(arg0).getRandomValues(getObject(arg1));
}, arguments) };

export function __wbg_getTime_14776bfb48a1bff9(arg0) {
    const ret = getObject(arg0).getTime();
    return ret;
};

export function __wbg_get_7a8d8d4660d2458b() { return handleError(function (arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).get(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_get_7bed016f185add81(arg0, arg1) {
    const ret = getObject(arg0)[arg1 >>> 0];
    return addHeapObject(ret);
};

export function __wbg_get_access_token_12bc2955840b45ee(arg0) {
    const ret = getObject(arg0).get_access_token();
    return addHeapObject(ret);
};

export function __wbg_get_c03a59ff46a549dd() { return handleError(function (arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).get(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_get_efcb449f58ec27c2() { return handleError(function (arg0, arg1) {
    const ret = Reflect.get(getObject(arg0), getObject(arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_get_f64294d3c1a3d3fc() { return handleError(function (arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).get(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_get_fb1fa70beb44a754() { return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).get(getObject(arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_get_with_ref_key_1dc361bd10053bfe(arg0, arg1) {
    const ret = getObject(arg0)[getObject(arg1)];
    return addHeapObject(ret);
};

export function __wbg_has_787fafc980c3ccdb() { return handleError(function (arg0, arg1) {
    const ret = Reflect.has(getObject(arg0), getObject(arg1));
    return ret;
}, arguments) };

export function __wbg_headers_b87d7eaba61c3278(arg0) {
    const ret = getObject(arg0).headers;
    return addHeapObject(ret);
};

export function __wbg_incomingmessage_new(arg0) {
    const ret = IncomingMessage.__wrap(arg0);
    return addHeapObject(ret);
};

export function __wbg_indexedDB_62bfbbd55ec74b14() { return handleError(function (arg0) {
    const ret = getObject(arg0).indexedDB;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
}, arguments) };

export function __wbg_indexedDB_8b464318fe56681e() { return handleError(function (arg0) {
    const ret = getObject(arg0).indexedDB;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
}, arguments) };

export function __wbg_info_68cd5b51ef7e5137(arg0, arg1, arg2, arg3) {
    console.info(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
};

export function __wbg_info_e674a11f4f50cc0c(arg0) {
    console.info(getObject(arg0));
};

export function __wbg_instanceof_ArrayBuffer_70beb1189ca63b38(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof ArrayBuffer;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_DomException_83b15e7b042a0b1a(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof DOMException;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_IdbDatabase_fcf75ffeeec3ec8c(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof IDBDatabase;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_IdbOpenDbRequest_08e4929084e51476(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof IDBOpenDBRequest;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_IdbRequest_26754883a3cc8f81(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof IDBRequest;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Map_8579b5e2ab5437c7(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof Map;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Response_f4f3e87e07f3135c(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof Response;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Uint8Array_20c8e73002f7af98(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof Uint8Array;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_Window_4846dbb3de56c84c(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof Window;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_instanceof_WorkerGlobalScope_e31f49b6d33fcadd(arg0) {
    let result;
    try {
        result = getObject(arg0) instanceof WorkerGlobalScope;
    } catch (_) {
        result = false;
    }
    const ret = result;
    return ret;
};

export function __wbg_ipcclientsubscription_new(arg0) {
    const ret = IpcClientSubscription.__wrap(arg0);
    return addHeapObject(ret);
};

export function __wbg_isArray_96e0af9891d0945d(arg0) {
    const ret = Array.isArray(getObject(arg0));
    return ret;
};

export function __wbg_isSafeInteger_d216eda7911dde36(arg0) {
    const ret = Number.isSafeInteger(getObject(arg0));
    return ret;
};

export function __wbg_iterator_e5822695327a3c39() {
    const ret = Symbol.iterator;
    return addHeapObject(ret);
};

export function __wbg_length_69bca3cb64fc8748(arg0) {
    const ret = getObject(arg0).length;
    return ret;
};

export function __wbg_length_cdd215e10d9dd507(arg0) {
    const ret = getObject(arg0).length;
    return ret;
};

export function __wbg_list_dc27258af9d787e1() { return handleError(function (arg0) {
    const ret = getObject(arg0).list();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_list_eca697e410e62bb7() { return handleError(function (arg0) {
    const ret = getObject(arg0).list();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_msCrypto_d562bbe83e0d4b91(arg0) {
    const ret = getObject(arg0).msCrypto;
    return addHeapObject(ret);
};

export function __wbg_name_3a33ad25b892b2dd(arg0, arg1) {
    const ret = getObject(arg1).name;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_new_0_f9740686d739025c() {
    const ret = new Date();
    return addHeapObject(ret);
};

export function __wbg_new_122699422a56c70d(arg0, arg1) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg0;
        deferred0_1 = arg1;
        const ret = new Error(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
};

export function __wbg_new_1acc0b6eea89d040() {
    const ret = new Object();
    return addHeapObject(ret);
};

export function __wbg_new_2531773dac38ebb3() { return handleError(function () {
    const ret = new AbortController();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_new_3c3d849046688a66(arg0, arg1) {
    try {
        var state0 = {a: arg0, b: arg1};
        var cb0 = (arg0, arg1) => {
            const a = state0.a;
            state0.a = 0;
            try {
                return wasm_bindgen__convert__closures_____invoke__hc4d57ad329cc6f58(a, state0.b, arg0, arg1);
            } finally {
                state0.a = a;
            }
        };
        const ret = new Promise(cb0);
        return addHeapObject(ret);
    } finally {
        state0.a = state0.b = 0;
    }
};

export function __wbg_new_5a79be3ab53b8aa5(arg0) {
    const ret = new Uint8Array(getObject(arg0));
    return addHeapObject(ret);
};

export function __wbg_new_68651c719dcda04e() {
    const ret = new Map();
    return addHeapObject(ret);
};

export function __wbg_new_6f694bb0585846e0() { return handleError(function () {
    const ret = new FormData();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_new_8a6f238a6ece86ea() {
    const ret = new Error();
    return addHeapObject(ret);
};

export function __wbg_new_9edf9838a2def39c() { return handleError(function () {
    const ret = new Headers();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_new_a7442b4b19c1a356(arg0, arg1) {
    const ret = new Error(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

export function __wbg_new_e17d9f43105b08be() {
    const ret = new Array();
    return addHeapObject(ret);
};

export function __wbg_new_from_slice_92f4d78ca282a2d2(arg0, arg1) {
    const ret = new Uint8Array(getArrayU8FromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

export function __wbg_new_no_args_ee98eee5275000a4(arg0, arg1) {
    const ret = new Function(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
};

export function __wbg_new_with_length_01aa0dc35aa13543(arg0) {
    const ret = new Uint8Array(arg0 >>> 0);
    return addHeapObject(ret);
};

export function __wbg_new_with_length_31d2669cb75c5215(arg0) {
    const ret = new Array(arg0 >>> 0);
    return addHeapObject(ret);
};

export function __wbg_new_with_str_and_init_0ae7728b6ec367b1() { return handleError(function (arg0, arg1, arg2) {
    const ret = new Request(getStringFromWasm0(arg0, arg1), getObject(arg2));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_new_with_u8_array_sequence_and_options_0c1d0bd56d93d25a() { return handleError(function (arg0, arg1) {
    const ret = new Blob(getObject(arg0), getObject(arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_next_020810e0ae8ebcb0() { return handleError(function (arg0) {
    const ret = getObject(arg0).next();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_next_2c826fe5dfec6b6a(arg0) {
    const ret = getObject(arg0).next;
    return addHeapObject(ret);
};

export function __wbg_node_e1f24f89a7336c2e(arg0) {
    const ret = getObject(arg0).node;
    return addHeapObject(ret);
};

export function __wbg_now_f5ba683d8ce2c571(arg0) {
    const ret = getObject(arg0).now();
    return ret;
};

export function __wbg_objectStore_2aab1d8b165c62a6() { return handleError(function (arg0, arg1, arg2) {
    const ret = getObject(arg0).objectStore(getStringFromWasm0(arg1, arg2));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_open_9d8c51d122a5a6ea() { return handleError(function (arg0, arg1, arg2, arg3) {
    const ret = getObject(arg0).open(getStringFromWasm0(arg1, arg2), arg3 >>> 0);
    return addHeapObject(ret);
}, arguments) };

export function __wbg_parse_2a704d6b78abb2b8() { return handleError(function (arg0, arg1) {
    const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_preventDefault_1f362670ce7ef430(arg0) {
    getObject(arg0).preventDefault();
};

export function __wbg_process_3975fd6c72f520aa(arg0) {
    const ret = getObject(arg0).process;
    return addHeapObject(ret);
};

export function __wbg_prototypesetcall_2a6620b6922694b2(arg0, arg1, arg2) {
    Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), getObject(arg2));
};

export function __wbg_push_df81a39d04db858c(arg0, arg1) {
    const ret = getObject(arg0).push(getObject(arg1));
    return ret;
};

export function __wbg_put_88678dd575c85637() { return handleError(function (arg0, arg1, arg2) {
    const ret = getObject(arg0).put(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_queueMicrotask_34d692c25c47d05b(arg0) {
    const ret = getObject(arg0).queueMicrotask;
    return addHeapObject(ret);
};

export function __wbg_queueMicrotask_9d76cacb20c84d58(arg0) {
    queueMicrotask(getObject(arg0));
};

export function __wbg_randomFillSync_f8c153b79f285817() { return handleError(function (arg0, arg1) {
    getObject(arg0).randomFillSync(takeObject(arg1));
}, arguments) };

export function __wbg_remove_75ff3d2381eeb516() { return handleError(function (arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).remove(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_remove_8183d9d6887d3048() { return handleError(function (arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).remove(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_require_b74f47fc2d022fd6() { return handleError(function () {
    const ret = module.require;
    return addHeapObject(ret);
}, arguments) };

export function __wbg_resolve_caf97c30b83f7053(arg0) {
    const ret = Promise.resolve(getObject(arg0));
    return addHeapObject(ret);
};

export function __wbg_result_25e75004b82b9830() { return handleError(function (arg0) {
    const ret = getObject(arg0).result;
    return addHeapObject(ret);
}, arguments) };

export function __wbg_save_5a855c0dde023a63() { return handleError(function (arg0, arg1, arg2, arg3) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).save(getStringFromWasm0(arg1, arg2), takeObject(arg3));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_send_8b64d9aa7f1992ee() { return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).send(OutgoingMessage.__wrap(arg1));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_setTimeout_4ec014681668a581(arg0, arg1) {
    const ret = setTimeout(getObject(arg0), arg1);
    return addHeapObject(ret);
};

export function __wbg_set_3f1d0b984ed272ed(arg0, arg1, arg2) {
    getObject(arg0)[takeObject(arg1)] = takeObject(arg2);
};

export function __wbg_set_73534dc44666720f() { return handleError(function (arg0, arg1, arg2, arg3) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).set(getStringFromWasm0(arg1, arg2), takeObject(arg3));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_set_7c4bcc3022a0f370() { return handleError(function (arg0, arg1, arg2, arg3) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        const ret = getObject(arg0).set(getStringFromWasm0(arg1, arg2), takeObject(arg3));
        return addHeapObject(ret);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
}, arguments) };

export function __wbg_set_907fb406c34a251d(arg0, arg1, arg2) {
    const ret = getObject(arg0).set(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
};

export function __wbg_set_body_3c365989753d61f4(arg0, arg1) {
    getObject(arg0).body = getObject(arg1);
};

export function __wbg_set_c213c871859d6500(arg0, arg1, arg2) {
    getObject(arg0)[arg1 >>> 0] = takeObject(arg2);
};

export function __wbg_set_cache_2f9deb19b92b81e3(arg0, arg1) {
    getObject(arg0).cache = __wbindgen_enum_RequestCache[arg1];
};

export function __wbg_set_credentials_f621cd2d85c0c228(arg0, arg1) {
    getObject(arg0).credentials = __wbindgen_enum_RequestCredentials[arg1];
};

export function __wbg_set_headers_6926da238cd32ee4(arg0, arg1) {
    getObject(arg0).headers = getObject(arg1);
};

export function __wbg_set_method_c02d8cbbe204ac2d(arg0, arg1, arg2) {
    getObject(arg0).method = getStringFromWasm0(arg1, arg2);
};

export function __wbg_set_mode_52ef73cfa79639cb(arg0, arg1) {
    getObject(arg0).mode = __wbindgen_enum_RequestMode[arg1];
};

export function __wbg_set_name_f4b29c43a961f90e(arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        getObject(arg0).name = getStringFromWasm0(arg1, arg2);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
};

export function __wbg_set_onerror_dc82fea584ffccaa(arg0, arg1) {
    getObject(arg0).onerror = getObject(arg1);
};

export function __wbg_set_onsuccess_f367d002b462109e(arg0, arg1) {
    getObject(arg0).onsuccess = getObject(arg1);
};

export function __wbg_set_onupgradeneeded_0a519a73284a1418(arg0, arg1) {
    getObject(arg0).onupgradeneeded = getObject(arg1);
};

export function __wbg_set_signal_dda2cf7ccb6bee0f(arg0, arg1) {
    getObject(arg0).signal = getObject(arg1);
};

export function __wbg_set_type_63fa4c18251f6545(arg0, arg1, arg2) {
    getObject(arg0).type = getStringFromWasm0(arg1, arg2);
};

export function __wbg_set_variant_753180e89ea29c02(arg0, arg1, arg2) {
    let deferred0_0;
    let deferred0_1;
    try {
        deferred0_0 = arg1;
        deferred0_1 = arg2;
        getObject(arg0).variant = getStringFromWasm0(arg1, arg2);
    } finally {
        wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
    }
};

export function __wbg_signal_4db5aa055bf9eb9a(arg0) {
    const ret = getObject(arg0).signal;
    return addHeapObject(ret);
};

export function __wbg_stack_0ed75d68575b0f3c(arg0, arg1) {
    const ret = getObject(arg1).stack;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_static_accessor_GLOBAL_89e1d9ac6a1b250e() {
    const ret = typeof global === 'undefined' ? null : global;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_static_accessor_GLOBAL_THIS_8b530f326a9e48ac() {
    const ret = typeof globalThis === 'undefined' ? null : globalThis;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_static_accessor_SELF_6fdf4b64710cc91b() {
    const ret = typeof self === 'undefined' ? null : self;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_static_accessor_WINDOW_b45bfc5a37f6cfa2() {
    const ret = typeof window === 'undefined' ? null : window;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_static_accessor_performance_da77b3a901a72934() {
    const ret = performance;
    return addHeapObject(ret);
};

export function __wbg_status_de7eed5a7a5bfd5d(arg0) {
    const ret = getObject(arg0).status;
    return ret;
};

export function __wbg_stringify_b5fb28f6465d9c3e() { return handleError(function (arg0) {
    const ret = JSON.stringify(getObject(arg0));
    return addHeapObject(ret);
}, arguments) };

export function __wbg_subarray_480600f3d6a9f26c(arg0, arg1, arg2) {
    const ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
    return addHeapObject(ret);
};

export function __wbg_target_1447f5d3a6fa6fe0(arg0) {
    const ret = getObject(arg0).target;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_text_dc33c15c17bdfb52() { return handleError(function (arg0) {
    const ret = getObject(arg0).text();
    return addHeapObject(ret);
}, arguments) };

export function __wbg_then_4f46f6544e6b4a28(arg0, arg1) {
    const ret = getObject(arg0).then(getObject(arg1));
    return addHeapObject(ret);
};

export function __wbg_then_70d05cf780a18d77(arg0, arg1, arg2) {
    const ret = getObject(arg0).then(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
};

export function __wbg_transaction_9fb8349a0a81725c(arg0) {
    const ret = getObject(arg0).transaction;
    return isLikeNone(ret) ? 0 : addHeapObject(ret);
};

export function __wbg_transaction_cd940bd89781f616() { return handleError(function (arg0, arg1, arg2) {
    const ret = getObject(arg0).transaction(getObject(arg1), __wbindgen_enum_IdbTransactionMode[arg2]);
    return addHeapObject(ret);
}, arguments) };

export function __wbg_url_b36d2a5008eb056f(arg0, arg1) {
    const ret = getObject(arg1).url;
    const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len1 = WASM_VECTOR_LEN;
    getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
    getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
};

export function __wbg_value_692627309814bb8c(arg0) {
    const ret = getObject(arg0).value;
    return addHeapObject(ret);
};

export function __wbg_versions_4e31226f5e8dc909(arg0) {
    const ret = getObject(arg0).versions;
    return addHeapObject(ret);
};

export function __wbg_warn_1d74dddbe2fd1dbb(arg0) {
    console.warn(getObject(arg0));
};

export function __wbg_warn_8f5b5437666d0885(arg0, arg1, arg2, arg3) {
    console.warn(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
};

export function __wbindgen_cast_0fdbcf386e502740(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { dtor_idx: 384, function: Function { arguments: [NamedExternref("Event")], shim_idx: 41, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__ha6acfc0fc44e75c9, wasm_bindgen__convert__closures_____invoke__h50b4f01e700bd46b);
    return addHeapObject(ret);
};

export function __wbindgen_cast_2241b6af4c4b2941(arg0, arg1) {
    // Cast intrinsic for `Ref(String) -> Externref`.
    const ret = getStringFromWasm0(arg0, arg1);
    return addHeapObject(ret);
};

export function __wbindgen_cast_2529bb841190142b(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { dtor_idx: 365, function: Function { arguments: [], shim_idx: 366, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h14b8abadf056d28e, wasm_bindgen__convert__closures_____invoke__h7c6e0808d83e1743);
    return addHeapObject(ret);
};

export function __wbindgen_cast_34ef3ce950757bdd(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { dtor_idx: 40, function: Function { arguments: [NamedExternref("IDBVersionChangeEvent")], shim_idx: 41, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h4401c3c59528812f, wasm_bindgen__convert__closures_____invoke__h50b4f01e700bd46b);
    return addHeapObject(ret);
};

export function __wbindgen_cast_397295739b4135cd(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { dtor_idx: 40, function: Function { arguments: [NamedExternref("Event")], shim_idx: 43, ret: Result(Unit), inner_ret: Some(Result(Unit)) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h4401c3c59528812f, wasm_bindgen__convert__closures_____invoke__h7dd86ab58fba945e);
    return addHeapObject(ret);
};

export function __wbindgen_cast_4625c577ab2ec9ee(arg0) {
    // Cast intrinsic for `U64 -> Externref`.
    const ret = BigInt.asUintN(64, arg0);
    return addHeapObject(ret);
};

export function __wbindgen_cast_5fea77eff9dd275c(arg0, arg1) {
    var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
    wasm.__wbindgen_free(arg0, arg1 * 4, 4);
    // Cast intrinsic for `Vector(NamedExternref("CipherRiskResult")) -> Externref`.
    const ret = v0;
    return addHeapObject(ret);
};

export function __wbindgen_cast_76926981342b91ce(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { dtor_idx: 638, function: Function { arguments: [], shim_idx: 366, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h2b9785764fab287c, wasm_bindgen__convert__closures_____invoke__h7c6e0808d83e1743);
    return addHeapObject(ret);
};

export function __wbindgen_cast_76b329ef067f9238(arg0, arg1) {
    var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
    wasm.__wbindgen_free(arg0, arg1 * 4, 4);
    // Cast intrinsic for `Vector(NamedExternref("V1OrganizationMembership")) -> Externref`.
    const ret = v0;
    return addHeapObject(ret);
};

export function __wbindgen_cast_7a6d185652cd8149(arg0, arg1) {
    var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
    wasm.__wbindgen_free(arg0, arg1 * 4, 4);
    // Cast intrinsic for `Vector(NamedExternref("Cipher")) -> Externref`.
    const ret = v0;
    return addHeapObject(ret);
};

export function __wbindgen_cast_8db579d9b3baafc0(arg0, arg1) {
    // Cast intrinsic for `Closure(Closure { dtor_idx: 365, function: Function { arguments: [Externref], shim_idx: 41, ret: Unit, inner_ret: Some(Unit) }, mutable: true }) -> Externref`.
    const ret = makeMutClosure(arg0, arg1, wasm.wasm_bindgen__closure__destroy__h14b8abadf056d28e, wasm_bindgen__convert__closures_____invoke__h50b4f01e700bd46b);
    return addHeapObject(ret);
};

export function __wbindgen_cast_9ae0607507abb057(arg0) {
    // Cast intrinsic for `I64 -> Externref`.
    const ret = arg0;
    return addHeapObject(ret);
};

export function __wbindgen_cast_b4ad3c8588340a04(arg0, arg1) {
    var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
    wasm.__wbindgen_free(arg0, arg1 * 4, 4);
    // Cast intrinsic for `Vector(NamedExternref("V1EmergencyAccessMembership")) -> Externref`.
    const ret = v0;
    return addHeapObject(ret);
};

export function __wbindgen_cast_cb9088102bce6b30(arg0, arg1) {
    // Cast intrinsic for `Ref(Slice(U8)) -> NamedExternref("Uint8Array")`.
    const ret = getArrayU8FromWasm0(arg0, arg1);
    return addHeapObject(ret);
};

export function __wbindgen_cast_d6cd19b81560fd6e(arg0) {
    // Cast intrinsic for `F64 -> Externref`.
    const ret = arg0;
    return addHeapObject(ret);
};

export function __wbindgen_cast_ef90a087adb7475d(arg0, arg1) {
    var v0 = getArrayJsValueFromWasm0(arg0, arg1).slice();
    wasm.__wbindgen_free(arg0, arg1 * 4, 4);
    // Cast intrinsic for `Vector(NamedExternref("FolderView")) -> Externref`.
    const ret = v0;
    return addHeapObject(ret);
};

export function __wbindgen_object_clone_ref(arg0) {
    const ret = getObject(arg0);
    return addHeapObject(ret);
};

export function __wbindgen_object_drop_ref(arg0) {
    takeObject(arg0);
};

